var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoClovai(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1921,
    height: 482,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 1340 0.5 L 1320.5 3 L 1293.5 12 Q 1268.7 22.7 1251 40.5 L 1248 44.5 L 1248 48.5 L 1262.5 54 L 1294 60 L 1292.5 63 L 1279 75.5 L 1277 83 L 1286.5 86 L 1302.5 87 L 1303.5 88 L 1349.5 89 L 1354.5 88 L 1351 92.5 L 1347 99.5 L 1347 103 L 1358.5 105 L 1391.5 105 L 1392.5 104 L 1408.5 104 L 1409.5 103 L 1427.5 102 L 1456.5 97 L 1486.5 88 L 1495.5 84 L 1504 77.5 L 1505 71.5 L 1501.5 67 Q 1469 38 1426.5 19 L 1386.5 5 L 1372.5 2 L 1356 0.5 L 1703.5 0 L 1703.5 1 L 1697.5 1 L 1678.5 5 L 1637.5 20 L 1602.5 39 L 1564 68 Q 1562.4 70.1 1563 75.5 L 1568.5 81 L 1583.5 88 L 1619.5 98 L 1637.5 100 L 1638.5 101 L 1645.5 101 L 1646.5 102 L 1669.5 103 L 1670.5 104 L 1713.5 104 Q 1714.7 101.8 1719.5 103 L 1721 101.5 L 1720 96.5 L 1713 87.5 L 1714.5 88 L 1753.5 88 L 1754.5 87 L 1767.5 87 L 1768.5 86 L 1782.5 85 L 1791 81.5 Q 1788.2 69.3 1778.5 64 L 1774 60.5 L 1775.5 59 L 1806.5 53 L 1816.5 50 L 1820 47.5 L 1819 42.5 L 1808.5 32 Q 1780.4 7.6 1735 0.5 L 1921 0 L 1920.5 227 L 1919 206.5 L 1916 189.5 Q 1910.8 166.2 1902 146.5 Q 1885.5 110.5 1858.5 85 L 1833.5 65 L 1827.5 65 L 1809 69.5 L 1822 82.5 L 1826 89.5 L 1826 92.5 L 1822.5 97 L 1814.5 100 L 1793.5 102 L 1792.5 103 L 1738 104 L 1743 113.5 L 1743 117.5 L 1739.5 121 L 1729.5 123 L 1682.5 123 L 1681.5 122 L 1667.5 122 L 1666.5 121 L 1647.5 120 L 1646.5 119 L 1640.5 119 L 1611.5 114 L 1582.5 106 L 1553.5 93 L 1546.5 93 Q 1539.5 94.5 1536 99.5 L 1528.5 109 L 1525 106.5 L 1516.5 96 Q 1512.3 91.7 1502.5 93 L 1476.5 105 L 1434.5 116 L 1429.5 116 L 1416.5 119 L 1409.5 119 L 1408.5 120 L 1389.5 121 L 1388.5 122 L 1375.5 122 L 1374.5 123 L 1326.5 123 L 1316.5 121 L 1314 118.5 L 1313 114.5 L 1318 104 L 1278.5 104 L 1277.5 103 L 1254.5 102 L 1237.5 99 L 1231 94.5 L 1230 90.5 Q 1235.8 77.3 1247 69.5 L 1229.5 65 L 1222.5 65 Q 1200.3 80.3 1183 100.5 Q 1156.9 130.9 1144 174.5 L 1139 195.5 L 1137 215.5 L 1136 216.5 L 1135 253.5 L 1136 254.5 L 1137 276.5 L 1141 298.5 L 1153 335.5 Q 1171.9 378.6 1205.5 407 Q 1235.1 432.4 1276.5 446 L 1295.5 451 L 1318.5 455 L 1359.5 457 L 1360.5 456 L 1385.5 455 L 1408.5 451 Q 1434.5 445.3 1455 435 L 1435 382.5 L 1432 366.5 L 1432 349.5 L 1435 333.5 L 1443 313.5 Q 1451.1 298.6 1463.5 288 Q 1478 275.5 1498.5 269 L 1518.5 265 L 1537.5 265 L 1557.5 269 L 1578.5 278 Q 1592.8 286.2 1603 298.5 Q 1614.8 312.7 1621 332.5 L 1624 347.5 L 1624 367.5 L 1617 394.5 L 1601 435 L 1622.5 444 L 1647.5 451 L 1670.5 455 L 1678.5 455 L 1679.5 456 L 1711.5 457 L 1712.5 456 L 1737.5 455 L 1760.5 451 Q 1781 446.5 1798.5 439 Q 1837 422.5 1864 394.5 Q 1888.9 368.9 1904 333.5 L 1915 299.5 L 1919 277.5 L 1920.5 257 L 1921 482 L 1538 481.5 Q 1557.1 477.6 1567 464.5 L 1574 453.5 L 1601 382.5 L 1604 369.5 L 1604 347.5 Q 1598.8 319.7 1581.5 304 Q 1562.2 284.8 1524.5 284 L 1523.5 285 L 1509.5 286 L 1494.5 291 Q 1477.7 298.7 1467 312.5 Q 1458.4 323.4 1454 338.5 L 1452 348.5 L 1452 368.5 L 1457 387.5 L 1481 450.5 Q 1485.8 462.2 1494.5 470 L 1508.5 479 L 1518 481.5 L 0 482 L 0.5 233 L 4 256.5 L 12 279.5 Q 22.6 301.9 39.5 318 Q 59 336.5 87.5 346 L 103.5 350 L 117.5 351 L 118.5 352 L 142.5 352 L 143.5 351 L 154.5 351 L 165.5 349 L 190.5 341 Q 217.8 328.8 236 307.5 Q 245.2 297.7 251 284.5 L 253 270.5 L 249 257.5 L 239.5 247 L 229.5 242 L 217.5 241 Q 200.3 243.8 192 255.5 Q 185.8 268.3 174.5 276 Q 165.3 284.3 151.5 288 L 139.5 289 L 138.5 290 L 128.5 290 L 112.5 287 L 97.5 280 L 82 266.5 Q 73.4 256.6 69 242.5 L 66 227.5 L 66 208.5 L 71 188.5 Q 77 174 87.5 164 Q 96.9 154.9 110.5 150 L 122.5 147 L 144.5 147 L 153.5 149 L 165.5 154 Q 178 161.5 187 172.5 L 196.5 186 L 210.5 194 L 226.5 195 Q 238.5 192.5 245 184.5 Q 253 176.5 253 160.5 Q 245.5 133 225.5 118 Q 203 98.5 170.5 89 L 151.5 85 L 122.5 84 L 121.5 85 L 112.5 85 L 111.5 86 L 100.5 87 L 77.5 94 Q 50.6 105.1 33 125.5 Q 19 142.5 10 164.5 L 2 191.5 L 0.5 205 L 0 0 Z M 301 84 L 287 89 L 276 101 L 272 115 L 272 323 L 274 332 L 280 342 Q 286 350 299 352 Q 318 354 327 344 Q 333 338 336 328 L 336 314 Q 327 301 322 285 L 318 268 L 317 252 L 316 251 Q 315 200 336 172 L 336 109 L 331 98 Q 326 90 317 86 L 309 84 L 301 84 Z M 1004 84 L 996 86 L 989 90 Q 979 96 976 109 L 976 125 L 982 137 L 991 144 L 1000 148 Q 1005 147 1007 149 Q 1019 149 1027 143 Q 1037 136 1040 122 Q 1041 103 1032 95 Q 1023 84 1004 84 Z M 441 133 L 440 134 L 423 135 L 404 140 Q 384 147 370 160 Q 354 174 345 194 L 338 215 L 337 226 L 336 227 L 336 241 L 335 242 L 336 245 L 336 260 L 340 279 Q 347 299 359 315 Q 369 327 384 336 Q 396 344 412 348 L 434 352 L 460 352 L 482 348 Q 506 341 523 326 Q 547 306 555 269 L 522 186 L 518 172 L 518 160 L 519 158 L 507 148 L 495 142 L 480 137 L 464 134 L 441 133 Z M 568 133 L 558 135 L 548 141 Q 539 148 537 162 L 537 169 L 540 180 L 597 326 L 602 334 Q 613 348 634 352 L 649 352 L 654 351 Q 665 348 673 341 Q 680 334 685 325 L 707 268 L 706 255 L 705 254 L 706 223 L 713 195 Q 723 168 741 151 L 739 147 L 729 137 L 722 134 Q 716 136 715 133 L 705 134 L 696 138 Q 687 143 683 154 L 643 260 Q 644 262 640 261 L 600 157 L 595 147 Q 590 139 581 135 L 568 133 Z M 828 133 L 827 134 L 817 134 L 806 136 L 790 141 Q 773 147 761 158 Q 742 173 732 198 L 727 214 L 725 225 L 725 234 L 724 235 L 724 251 L 725 252 L 725 261 L 728 276 Q 734 298 747 314 Q 758 327 773 336 Q 785 344 801 348 L 824 352 L 848 352 L 849 351 L 862 350 Q 882 346 898 336 L 900 340 Q 906 349 920 352 L 932 352 L 946 345 L 953 336 L 956 325 L 956 161 L 951 147 Q 944 136 930 133 Q 914 132 907 139 L 898 150 L 884 142 L 865 136 L 854 134 L 844 134 L 843 133 L 828 133 Z M 1002 155 Q 992 157 986 163 Q 979 169 976 180 L 976 328 L 983 342 Q 989 350 1002 352 L 1014 352 L 1028 346 Q 1037 339 1040 326 L 1040 182 L 1034 168 Q 1025 154 1002 155 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 439.5 193 L 453.5 193 L 464.5 196 Q 476 200.5 483 209.5 Q 494.2 222.3 494 246.5 L 490 264.5 Q 485.4 274.9 477.5 282 L 461.5 291 L 451.5 293 L 440.5 293 Q 419.4 289.6 409 275.5 Q 397.6 261.9 399 235.5 Q 401.3 234.3 400 229.5 L 406 214.5 L 417.5 202 L 425.5 197 L 439.5 193 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 827.5 193 L 842.5 193 L 853.5 196 Q 865 200.5 872 209.5 Q 884.8 223.2 882 252.5 Q 878 273.5 863.5 284 Q 852 293.5 830.5 293 L 820.5 291 L 809.5 286 L 798 275.5 Q 791.8 267.8 789 256.5 L 788 251.5 L 788 233.5 Q 791.4 214.4 803.5 204 Q 812.6 195.6 827.5 193 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1222.5 65 L 1224 65.5 L 1220.5 68 L 1222.5 65 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1227.5 65 L 1230 65.5 L 1227.5 66 L 1227.5 65 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1827.5 65 L 1830 65.5 L 1827.5 66 L 1827.5 65 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1832.5 65 L 1839 69.5 L 1836.5 68 Q 1831.8 67.2 1832.5 65 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1231.5 66 L 1234 66.5 L 1231.5 67 L 1231.5 66 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1822.5 66 L 1825 66.5 L 1822.5 67 L 1822.5 66 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1236.5 67 L 1239 67.5 L 1236.5 68 L 1236.5 67 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1818.5 67 L 1821 67.5 L 1818.5 68 L 1818.5 67 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1218.5 68 L 1216.5 71 L 1207.5 78 L 1211.5 73 L 1218.5 68 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1240.5 68 L 1243 68.5 L 1240.5 69 L 1240.5 68 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1813.5 68 L 1816 68.5 L 1813.5 69 L 1813.5 68 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1245 69 L 1247 69.5 L 1232.5 85 L 1234 82.5 L 1245 69 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1809.5 69 Q 1811.8 68.3 1811 70.5 L 1821.5 82 L 1809.5 69 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1840.5 70 L 1842.5 73 L 1840.5 70 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1844.5 73 L 1847.5 77 L 1844.5 73 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1849.5 77 L 1856.5 85 L 1849.5 77 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1205.5 78 L 1184 100.5 L 1176.5 110 L 1179 106.5 L 1183 100.5 L 1205.5 78 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1822.5 83 L 1823.5 85 L 1822.5 83 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 122.5 84 L 142 84.5 L 122.5 85 L 122.5 84 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 300.5 84 L 309 84.5 L 300.5 85 L 300.5 84 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1003.5 84 L 1013 84.5 L 1003.5 85 L 1003.5 84 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 112.5 85 L 117 85.5 L 112.5 86 L 112.5 85 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 147.5 85 L 152 85.5 L 147.5 86 L 147.5 85 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 295.5 85 L 298 85.5 L 295.5 86 L 295.5 85 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 311.5 85 L 314 85.5 L 311.5 86 L 311.5 85 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 998.5 85 L 1001 85.5 L 998.5 86 L 998.5 85 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1858.5 85 Q 1872.2 97.8 1883 113.5 L 1880 111.5 L 1858.5 85 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 105.5 86 L 109 86.5 L 105.5 87 L 105.5 86 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 155.5 86 L 158 86.5 L 155.5 87 L 155.5 86 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 292.5 86 L 294 86.5 L 290.5 88 L 290.5 87 L 292.5 86 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 315.5 86 L 322 89.5 L 320.5 89 L 315.5 87 L 315.5 86 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 995.5 86 L 997 86.5 L 990.5 90 L 991.5 88 L 995.5 86 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1824.5 86 L 1826 88.5 L 1825 88.5 L 1824.5 86 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 100.5 87 L 103 87.5 L 100.5 88 L 100.5 87 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 160.5 87 L 163 87.5 L 160.5 88 L 160.5 87 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 96.5 88 L 99 88.5 L 96.5 89 L 96.5 88 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 164.5 88 L 167 88.5 L 164.5 89 L 164.5 88 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 288.5 88 L 287.5 90 L 278.5 98 L 286.5 89 L 288.5 88 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1023.5 88 L 1028 91.5 L 1025.5 90 L 1023.5 88 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 92.5 89 L 95 89.5 L 92.5 90 L 92.5 89 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 168.5 89 L 171 89.5 L 168.5 90 L 168.5 89 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 323.5 90 Q 330.8 94.8 334 103.5 L 333 103.5 Q 329.4 94.8 323.5 90 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 988.5 90 L 982 97.5 L 980.5 100 L 981 98.5 L 988.5 90 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 85.5 91 L 88 91.5 L 83.5 93 L 83.5 92 L 85.5 91 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1029.5 92 L 1031.5 95 L 1029.5 92 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1230.5 93 L 1233.5 97 L 1237 98.5 L 1235.5 99 L 1230 94.5 L 1230.5 93 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1502.5 93 L 1511 93.5 L 1502.5 94 L 1502.5 93 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1546.5 93 L 1554 93.5 L 1546.5 94 L 1546.5 93 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1825.5 93 L 1826 94.5 L 1819.5 99 L 1819.5 98 L 1825 94.5 L 1825.5 93 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 77.5 94 L 79 94.5 L 75.5 96 L 75.5 95 L 77.5 94 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1512.5 94 L 1515 95.5 L 1513.5 95 L 1512.5 94 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 186.5 95 L 190 96.5 L 188.5 97 L 186.5 95 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1541.5 95 L 1540.5 97 L 1536.5 100 L 1539.5 96 L 1541.5 95 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1032.5 96 L 1034.5 99 L 1032.5 96 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1516.5 96 L 1520.5 101 L 1516.5 96 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 193.5 98 L 200 101.5 L 198.5 101 L 193.5 99 L 193.5 98 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 277.5 99 L 277 100.5 L 275.5 104 L 275 102.5 L 277.5 99 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1238.5 99 L 1241 99.5 L 1238.5 100 L 1238.5 99 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1815.5 99 L 1818 99.5 L 1815.5 100 L 1815.5 99 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1243.5 100 L 1247 100.5 L 1243.5 101 L 1243.5 100 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1568.5 100 L 1572 101.5 L 1570.5 102 L 1568.5 100 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1810.5 100 L 1813 100.5 L 1810.5 101 L 1810.5 100 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 63.5 101 L 62.5 103 L 51.5 110 L 53.5 107 L 63.5 101 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1249.5 101 L 1254 101.5 L 1249.5 102 L 1249.5 101 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1484.5 101 L 1486 101.5 L 1482.5 103 L 1482.5 102 L 1484.5 101 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1535.5 101 L 1532 105.5 L 1528.5 111 L 1525.5 107 L 1528.5 109 L 1535.5 101 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1802.5 101 L 1807 101.5 L 1802.5 102 L 1802.5 101 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1258.5 102 L 1264 102.5 L 1258.5 103 L 1258.5 102 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1521.5 102 L 1524.5 106 L 1521.5 102 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1793.5 102 L 1799 102.5 L 1793.5 103 L 1793.5 102 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 203.5 103 L 207 105.5 L 205.5 105 L 203.5 103 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1269.5 103 L 1278 103.5 L 1269.5 104 L 1269.5 103 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1479.5 103 L 1481 103.5 L 1477.5 105 L 1477.5 104 L 1479.5 103 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1778.5 103 L 1787 103.5 L 1778.5 104 L 1778.5 103 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1288.5 104 L 1317.5 104 L 1318 105.5 L 1316 106.5 L 1316.5 105 L 1288.5 105 L 1288.5 104 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1578.5 104 L 1582 105.5 L 1580.5 106 L 1578.5 104 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1738.5 104 L 1743 112.5 L 1742 112.5 L 1738 105.5 L 1738.5 104 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1740.5 104 L 1768 104.5 L 1740.5 105 L 1740.5 104 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 208.5 106 Q 226.2 116.3 239 131.5 L 241 134.5 L 238 132.5 L 225.5 119 L 209.5 108 L 208.5 106 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1586.5 107 L 1592 108.5 L 1589.5 109 L 1586.5 108 L 1586.5 107 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 273.5 108 L 274 110.5 L 273 110.5 L 273.5 108 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 335.5 108 L 336 110.5 L 335 110.5 L 335.5 108 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 976.5 108 L 977 110.5 L 976 110.5 L 976.5 108 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1315.5 108 L 1315 109.5 L 1313.5 114 L 1313 111.5 L 1315.5 108 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1464.5 108 L 1467 108.5 L 1464.5 109 L 1464.5 108 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 49.5 110 L 46.5 114 L 34 125.5 L 30.5 130 L 33 126.5 L 45.5 113 L 49.5 110 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1457.5 110 L 1460 110.5 L 1457.5 111 L 1457.5 110 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1596.5 110 L 1599 110.5 L 1596.5 111 L 1596.5 110 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1039.5 111 L 1040 121.5 L 1039 121.5 L 1039.5 111 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1175.5 111 L 1174 113.5 L 1166.5 125 L 1167 123.5 L 1175.5 111 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1453.5 111 L 1456 111.5 L 1453.5 112 L 1453.5 111 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1600.5 111 L 1603 111.5 L 1600.5 112 L 1600.5 111 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1449.5 112 L 1452 112.5 L 1449.5 113 L 1449.5 112 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1604.5 112 L 1607 112.5 L 1604.5 113 L 1604.5 112 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1445.5 113 L 1448 113.5 L 1445.5 114 L 1445.5 113 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1608.5 113 L 1611 113.5 L 1608.5 114 L 1608.5 113 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 272.5 114 L 273 322.5 L 272 322.5 L 272.5 114 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1440.5 114 L 1443 114.5 L 1440.5 115 L 1440.5 114 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1613.5 114 L 1616 114.5 L 1613.5 115 L 1613.5 114 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1435.5 115 L 1438 115.5 L 1435.5 116 L 1435.5 115 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1618.5 115 L 1621 115.5 L 1618.5 116 L 1618.5 115 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1883.5 115 L 1884.5 117 L 1883.5 115 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1429.5 116 L 1433 116.5 L 1429.5 117 L 1429.5 116 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1623.5 116 L 1627 116.5 L 1623.5 117 L 1623.5 116 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1313.5 117 L 1316.5 121 L 1319 121.5 L 1316.5 122 L 1313 118.5 L 1313.5 117 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1423.5 117 L 1427 117.5 L 1423.5 118 L 1423.5 117 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1629.5 117 L 1633 117.5 L 1629.5 118 L 1629.5 117 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1417.5 118 L 1421 118.5 L 1417.5 119 L 1417.5 118 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1635.5 118 L 1640 118.5 L 1635.5 119 L 1635.5 118 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1742.5 118 L 1739.5 122 L 1737 121.5 L 1742.5 118 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1885.5 118 L 1886.5 120 L 1885.5 118 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1409.5 119 L 1414 119.5 L 1409.5 120 L 1409.5 119 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1642.5 119 L 1647 119.5 L 1642.5 120 L 1642.5 119 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1400.5 120 L 1406 120.5 L 1400.5 121 L 1400.5 120 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1651.5 120 L 1656 120.5 L 1651.5 121 L 1651.5 120 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 976.5 121 L 977 124.5 L 976 124.5 L 976.5 121 Z "
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1389.5 121 L 1396 121.5 L 1389.5 122 L 1389.5 121 Z "
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1660.5 121 L 1667 121.5 L 1660.5 122 L 1660.5 121 Z "
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1887.5 121 L 1888.5 123 L 1887.5 121 Z "
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1321.5 122 L 1326 122.5 L 1321.5 123 L 1321.5 122 Z "
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1375.5 122 L 1384 122.5 L 1375.5 123 L 1375.5 122 Z "
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1673.5 122 L 1682 122.5 L 1673.5 123 L 1673.5 122 Z "
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1730.5 122 L 1735 122.5 L 1730.5 123 L 1730.5 122 Z "
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1335.5 123 L 1364 123.5 L 1335.5 124 L 1335.5 123 Z "
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1693.5 123 L 1722 123.5 L 1693.5 124 L 1693.5 123 Z "
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1889.5 124 L 1892 127.5 L 1890 126.5 L 1889.5 124 Z "
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 977.5 126 L 979 129.5 L 978 129.5 L 977.5 126 Z "
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1165.5 126 L 1165 127.5 L 1163.5 130 L 1164 128.5 L 1165.5 126 Z "
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 29.5 131 L 27.5 134 L 29.5 131 Z "
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1893.5 131 L 1902 147.5 L 1901 147.5 L 1893.5 131 Z "
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1035.5 132 L 1035 133.5 L 1026.5 143 L 1034 134.5 L 1035.5 132 Z "
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 440.5 133 L 452 133.5 L 440.5 134 L 440.5 133 Z "
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 567.5 133 L 571 133.5 L 567.5 134 L 567.5 133 Z "
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 711.5 133 L 715 133.5 L 711.5 134 L 711.5 133 Z "
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 827.5 133 L 843 133.5 L 827.5 134 L 827.5 133 Z "
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 920.5 133 L 930 133.5 L 920.5 134 L 920.5 133 Z "
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 980.5 133 L 981.5 135 L 980.5 133 Z "
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 428.5 134 L 434 134.5 L 428.5 135 L 428.5 134 Z "
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 459.5 134 L 464 134.5 L 459.5 135 L 459.5 134 Z "
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 560.5 134 L 563 134.5 L 560.5 135 L 560.5 134 Z "
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 574.5 134 L 577 134.5 L 574.5 135 L 574.5 134 Z "
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 704.5 134 L 707 134.5 L 704.5 135 L 704.5 134 Z "
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 719.5 134 Q 726.4 134.6 730 138.5 L 728.5 138 L 719.5 135 L 719.5 134 Z "
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 816.5 134 L 821 134.5 L 816.5 135 L 816.5 134 Z "
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 849.5 134 L 854 134.5 L 849.5 135 L 849.5 134 Z "
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 932.5 134 L 937 135.5 L 935.5 136 L 932.5 135 L 932.5 134 Z "
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 26.5 135 L 25.5 137 L 26.5 135 Z "
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 422.5 135 L 426 135.5 L 422.5 136 L 422.5 135 Z "
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 467.5 135 L 471 135.5 L 467.5 136 L 467.5 135 Z "
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 557.5 135 L 559 135.5 L 555.5 137 L 555.5 136 L 557.5 135 Z "
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 578.5 135 L 586 138.5 L 584.5 138 L 578.5 136 L 578.5 135 Z "
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 701.5 135 L 703 135.5 Q 692.5 139 687 147.5 L 683.5 155 L 683 153.5 Q 686.9 143.4 695.5 138 L 701.5 135 Z "
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 810.5 135 L 814 135.5 L 810.5 136 L 810.5 135 Z "
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 857.5 135 L 860 135.5 L 857.5 136 L 857.5 135 Z "
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 913.5 135 L 915 135.5 L 908.5 139 L 909.5 137 L 913.5 135 Z "
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1160.5 135 L 1160 136.5 L 1156.5 144 L 1156 142.5 L 1160.5 135 Z "
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 241.5 136 L 242.5 138 L 241.5 136 Z "
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 417.5 136 L 420 136.5 L 417.5 137 L 417.5 136 Z "
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 473.5 136 L 476 136.5 L 473.5 137 L 473.5 136 Z "
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 805.5 136 L 808 136.5 L 805.5 137 L 805.5 136 Z "
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 862.5 136 L 865 136.5 L 862.5 137 L 862.5 136 Z "
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 982.5 136 L 987.5 142 L 982.5 136 Z "
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 413.5 137 L 416 137.5 L 413.5 138 L 413.5 137 Z "
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 477.5 137 L 480 137.5 L 477.5 138 L 477.5 137 Z "
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 553.5 137 L 552.5 139 L 546 143.5 L 541.5 150 L 542 148.5 L 547.5 141 L 553.5 137 Z "
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 801.5 137 L 804 137.5 L 801.5 138 L 801.5 137 Z "
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 866.5 137 L 869 137.5 L 866.5 138 L 866.5 137 Z "
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 940.5 137 L 951 146.5 L 952 148.5 L 950 147.5 L 942.5 139 L 940.5 137 Z "
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 24.5 138 L 23.5 140 L 24.5 138 Z "
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 409.5 138 L 412 138.5 L 409.5 139 L 409.5 138 Z "
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 243.5 139 L 246 142.5 L 244 141.5 L 243.5 139 Z "
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 587.5 139 L 594.5 147 L 587.5 139 Z "
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 731.5 139 L 738.5 147 L 731.5 139 Z "
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 873.5 139 L 878 140.5 L 876.5 141 L 873.5 140 L 873.5 139 Z "
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 906.5 139 L 901 145.5 L 899.5 148 L 900 146.5 L 906.5 139 Z "
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 403.5 140 L 405 140.5 L 401.5 142 L 401.5 141 L 403.5 140 Z "
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 22.5 141 L 22 142.5 L 20.5 145 L 21 143.5 L 22.5 141 Z "
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 398.5 142 L 400 142.5 L 396.5 144 L 396.5 143 L 398.5 142 Z "
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 493.5 142 L 499 144.5 L 497.5 145 L 493.5 143 L 493.5 142 Z "
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 882.5 142 L 888 144.5 L 886.5 145 L 882.5 143 L 882.5 142 Z "
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 989.5 142 L 990.5 144 L 989.5 142 Z "
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 784.5 143 L 786 143.5 L 775.5 149 L 776.5 147 L 784.5 143 Z "
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1024.5 143 L 1023.5 145 L 1020.5 146 L 1020.5 145 L 1024.5 143 Z "
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 246.5 144 L 249 147.5 L 247 146.5 L 246.5 144 Z "
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 125.5 146 L 142 146.5 L 125.5 147 L 125.5 146 Z "
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 502.5 146 L 508 149.5 L 506.5 149 Q 502.5 148.5 502.5 146 Z "
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 891.5 146 L 897 149.5 L 895.5 149 Q 891.5 148.5 891.5 146 Z "
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 119.5 147 L 122 147.5 L 119.5 148 L 119.5 147 Z "
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 145.5 147 L 149 147.5 L 145.5 148 L 145.5 147 Z "
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 999.5 147 L 1002 147.5 L 999.5 148 L 999.5 147 Z "
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1013.5 147 L 1016 147.5 L 1013.5 148 L 1013.5 147 Z "
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1154.5 147 L 1155 148.5 L 1152.5 153 L 1152 151.5 L 1154.5 147 Z "
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 18.5 148 L 18 149.5 L 13.5 159 L 13 157.5 L 18.5 148 Z "
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 150.5 148 L 153 148.5 L 150.5 149 L 150.5 148 Z "
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 386.5 148 L 385.5 150 L 383.5 151 L 384.5 149 L 386.5 148 Z "
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 595.5 148 L 598 152.5 L 597 152.5 L 595.5 148 Z "
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 739.5 148 L 741 150.5 L 737 153.5 L 740 149.5 L 739.5 148 Z "
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1006.5 148 L 1010 148.5 L 1006.5 149 L 1006.5 148 Z "
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 111.5 149 L 114 149.5 L 111.5 150 L 111.5 149 Z "
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 154.5 149 L 159 150.5 L 157.5 151 L 154.5 150 L 154.5 149 Z "
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 249.5 149 L 251 152.5 L 250 152.5 L 249.5 149 Z "
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 773.5 149 L 772.5 151 Q 758.6 158.6 749 170.5 L 745.5 175 L 748 171.5 L 760.5 158 L 773.5 149 Z "
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 108.5 150 L 110 150.5 L 106.5 152 L 106.5 151 L 108.5 150 Z "
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 509.5 150 L 510.5 152 L 509.5 150 Z "
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 160.5 151 L 163 152.5 L 161.5 152 L 160.5 151 Z "
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 381.5 151 L 380.5 153 L 381.5 151 Z "
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1903.5 151 L 1905 154.5 L 1904 154.5 L 1903.5 151 Z "
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 512.5 152 L 513.5 154 L 512.5 152 Z "
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 378.5 153 L 376.5 156 L 378.5 153 Z "
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 166.5 154 L 171 157.5 L 168.5 156 L 166.5 154 Z "
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 251.5 154 L 252 156.5 L 251 156.5 L 251.5 154 Z "
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 515.5 154 L 519 158.5 L 518 158.5 L 515.5 154 Z "
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 598.5 154 L 600 157.5 L 599 157.5 L 598.5 154 Z "
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1151.5 154 L 1152 155.5 L 1150.5 158 L 1150 156.5 L 1151.5 154 Z "
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 98.5 155 L 97.5 157 L 98.5 155 Z "
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 736.5 155 L 732 160.5 L 723.5 173 L 724 171.5 Q 728.6 161.6 736.5 155 Z "
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 954.5 155 L 955 157.5 L 954 157.5 L 954.5 155 Z "
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1001.5 155 L 1006 155.5 L 1001.5 156 L 1001.5 155 Z "
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1010.5 155 L 1014 155.5 L 1010.5 156 L 1010.5 155 Z "
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 374.5 156 L 370.5 161 L 362.5 168 L 369.5 160 L 374.5 156 Z "
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 538.5 156 L 539 158.5 L 538 158.5 L 538.5 156 Z "
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 997.5 156 L 1000 156.5 L 995.5 158 L 995.5 157 L 997.5 156 Z "
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 95.5 157 L 94.5 159 L 95.5 157 Z "
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1019.5 157 Q 1028.8 160.2 1034 167.5 L 1038 175.5 L 1037 175.5 Q 1034.2 166.8 1027.5 162 L 1019.5 158 L 1019.5 157 Z "
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 172.5 158 L 174.5 161 L 172.5 158 Z "
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 992.5 158 L 994 158.5 L 991.5 160 L 992.5 158 Z "
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 92.5 159 L 88.5 164 L 84.5 167 L 87.5 163 L 92.5 159 Z "
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 681.5 159 L 682 160.5 L 680.5 163 L 680 161.5 L 681.5 159 Z "
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1906.5 159 L 1908 162.5 L 1907 162.5 L 1906.5 159 Z "
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 252.5 160 L 253 165.5 L 252 165.5 L 252.5 160 Z "
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 955.5 160 L 956 324.5 L 955 324.5 L 955.5 160 Z "
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 989.5 160 L 986.5 164 L 984.5 165 L 985.5 163 L 989.5 160 Z "
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 176.5 161 L 186.5 172 L 176.5 161 Z "
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 537.5 161 L 538 168.5 L 537 168.5 L 537.5 161 Z "
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 11.5 162 L 12 163.5 L 10.5 166 L 10 164.5 L 11.5 162 Z "
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 601.5 162 L 603 165.5 L 602 165.5 L 601.5 162 Z "
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 983.5 166 L 981 169.5 L 977.5 178 L 977 175.5 L 983.5 166 Z "
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 678.5 167 L 679 168.5 L 677.5 171 L 677 169.5 L 678.5 167 Z "
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 83.5 168 L 80 172.5 L 71.5 188 L 71 186.5 Q 75.1 175.1 83.5 168 Z "
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 251.5 169 L 252 171.5 L 251 171.5 L 251.5 169 Z "
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 361.5 169 L 358 173.5 L 351.5 183 L 352 181.5 L 361.5 169 Z "
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 8.5 170 L 9 171.5 L 7.5 175 L 7 172.5 L 8.5 170 Z "
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1910.5 170 L 1911 172.5 L 1910 172.5 L 1910.5 170 Z "
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 335.5 171 L 335 172.5 L 333.5 175 L 334 173.5 L 335.5 171 Z "
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 538.5 171 L 539 173.5 L 538 173.5 L 538.5 171 Z "
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 518.5 172 L 519 174.5 L 518 174.5 L 518.5 172 Z "
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 187.5 173 L 189.5 176 L 187.5 173 Z "
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 250.5 173 L 251 174.5 L 249.5 177 L 249 175.5 L 250.5 173 Z "
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 722.5 174 L 722 175.5 L 719.5 180 L 720 178.5 L 722.5 174 Z "
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1144.5 174 L 1145 176.5 L 1144 176.5 L 1144.5 174 Z "
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 606.5 175 L 608 178.5 L 607 178.5 L 606.5 175 Z "
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 675.5 175 L 676 176.5 L 674.5 179 L 674 177.5 L 675.5 175 Z "
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 744.5 176 L 743 178.5 L 741.5 181 L 742 179.5 L 744.5 176 Z "
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 190.5 177 L 191.5 179 L 190.5 177 Z "
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1038.5 177 L 1039 179.5 L 1038 179.5 L 1038.5 177 Z "
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1912.5 177 L 1913 179.5 L 1912 179.5 L 1912.5 177 Z "
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 248.5 178 L 248 179.5 L 245.5 183 L 247 180.5 L 248.5 178 Z "
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 331.5 178 L 331 179.5 L 329.5 183 L 329 181.5 L 331.5 178 Z "
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 540.5 178 L 542 181.5 L 541 181.5 L 540.5 178 Z "
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 976.5 179 L 977 181.5 L 976 181.5 L 976.5 179 Z "
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 192.5 180 L 197 185.5 L 195 184.5 L 192.5 180 Z "
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1039.5 181 L 1040 325.5 L 1039 325.5 L 1039.5 181 Z "
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1913.5 181 L 1914 183.5 L 1913 183.5 L 1913.5 181 Z "
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 740.5 182 L 740 183.5 L 738.5 186 L 739 184.5 L 740.5 182 Z "
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 542.5 183 L 544 186.5 L 543 186.5 L 542.5 183 Z "
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 609.5 183 L 611 186.5 L 610 186.5 L 609.5 183 Z "
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 672.5 183 L 673 184.5 L 671.5 187 L 671 185.5 L 672.5 183 Z "
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 717.5 183 L 718 184.5 L 715.5 189 L 715 187.5 L 717.5 183 Z "
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 244.5 184 L 241.5 188 L 238.5 190 L 240.5 187 L 244.5 184 Z "
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 350.5 184 L 350 185.5 L 345.5 195 L 345 193.5 L 350.5 184 Z "
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1914.5 185 L 1915 187.5 L 1914 187.5 L 1914.5 185 Z "
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 198.5 186 L 200.5 189 L 198.5 186 Z "
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 522.5 186 L 524 189.5 L 523 189.5 L 522.5 186 Z "
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1141.5 186 L 1142 188.5 L 1141 188.5 L 1141.5 186 Z "
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 3.5 187 L 4 189.5 L 3 189.5 L 3.5 187 Z "
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 326.5 188 L 327 189.5 L 325.5 192 L 325 190.5 L 326.5 188 Z "
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 670.5 188 L 671 189.5 L 669.5 192 L 669 190.5 L 670.5 188 Z "
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 202.5 189 L 209 192.5 L 207.5 193 Q 202.9 191.8 202.5 189 Z "
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1915.5 189 L 1916 192.5 L 1915 192.5 L 1915.5 189 Z "
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 236.5 190 L 235.5 192 L 234 191.5 L 236.5 190 Z "
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 714.5 190 L 715 191.5 L 713.5 194 L 713 192.5 L 714.5 190 Z "
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1140.5 190 L 1141 192.5 L 1140 192.5 L 1140.5 190 Z "
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 2.5 191 L 3 194.5 L 2 194.5 L 2.5 191 Z "
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 524.5 191 L 526 194.5 L 525 194.5 L 524.5 191 Z "
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 612.5 191 L 614 194.5 L 613 194.5 L 612.5 191 Z "
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 444.5 192 L 449 192.5 L 444.5 193 L 444.5 192 Z "
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 831.5 192 L 840 192.5 L 831.5 193 L 831.5 192 Z "
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 210.5 193 L 213 193.5 L 210.5 194 L 210.5 193 Z "
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 228.5 193 L 231 193.5 L 228.5 194 L 228.5 193 Z "
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 324.5 193 L 325 194.5 L 322.5 201 L 322 198.5 L 324.5 193 Z "
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 435.5 193 L 439 193.5 L 435.5 194 L 435.5 193 Z "
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 454.5 193 L 457 193.5 L 454.5 194 L 454.5 193 Z "
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 824.5 193 L 827 193.5 L 824.5 194 L 824.5 193 Z "
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 843.5 193 L 847 193.5 L 843.5 194 L 843.5 193 Z "
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 214.5 194 L 227 194.5 L 214.5 195 L 214.5 194 Z "
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 431.5 194 L 434 194.5 L 431.5 195 L 431.5 194 Z "
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 848.5 194 L 853 195.5 L 851.5 196 L 848.5 195 L 848.5 194 Z "
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1916.5 194 L 1917 197.5 L 1916 197.5 L 1916.5 194 Z "
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 428.5 195 L 430 195.5 L 426.5 197 L 426.5 196 L 428.5 195 Z "
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 733.5 195 L 734 196.5 L 732.5 199 L 732 197.5 L 733.5 195 Z "
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1139.5 195 L 1140 198.5 L 1139 198.5 L 1139.5 195 Z "
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 465.5 196 L 472 199.5 L 470.5 199 L 465.5 197 L 465.5 196 Z "
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 547.5 196 L 549 199.5 L 548 199.5 L 547.5 196 Z "
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 667.5 196 L 668 197.5 L 666.5 200 L 666 198.5 L 667.5 196 Z "
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 854.5 196 L 861 199.5 L 859.5 199 L 854.5 197 L 854.5 196 Z "
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1.5 197 L 2 200.5 L 1 200.5 L 1.5 197 Z "
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 812.5 197 L 814 197.5 L 811.5 199 L 812.5 197 Z "
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 422.5 198 L 421.5 200 Q 413 203.5 408.5 211 L 417.5 201 L 422.5 198 Z "
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 67.5 199 L 68 201.5 L 67 201.5 L 67.5 199 Z "
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 615.5 199 L 617 202.5 L 616 202.5 L 615.5 199 Z "
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 809.5 199 L 808.5 201 L 804.5 204 L 807.5 200 L 809.5 199 Z "
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 473.5 200 L 484 209.5 L 486 212.5 L 483 210.5 L 476.5 203 L 473.5 200 Z "
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 862.5 200 L 872 208.5 L 865.5 203 L 862.5 200 Z "
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1917.5 200 L 1918 203.5 L 1917 203.5 L 1917.5 200 Z "
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 549.5 201 L 551 204.5 L 550 204.5 L 549.5 201 Z "
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1138.5 201 L 1139 204.5 L 1138 204.5 L 1138.5 201 Z "
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 66.5 204 L 67 207.5 L 66 207.5 L 66.5 204 Z "
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 529.5 204 L 531 207.5 L 530 207.5 L 529.5 204 Z "
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 664.5 204 L 665 205.5 L 663.5 208 L 663 206.5 L 664.5 204 Z "
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 709.5 204 L 710 206.5 L 709 206.5 L 709.5 204 Z "
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 802.5 204 L 800 207.5 L 796.5 212 L 799 208.5 L 802.5 204 Z "
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 0.5 205 L 1 212.5 L 0 212.5 L 0.5 205 Z "
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 320.5 205 L 321 207.5 L 320 207.5 L 320.5 205 Z "
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1918.5 206 L 1919 210.5 L 1918 210.5 L 1918.5 206 Z "
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 618.5 207 L 620 210.5 L 619 210.5 L 618.5 207 Z "
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 708.5 208 L 709 210.5 L 708 210.5 L 708.5 208 Z "
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1137.5 208 L 1138 211.5 L 1137 211.5 L 1137.5 208 Z "
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 319.5 209 L 320 211.5 L 319 211.5 L 319.5 209 Z "
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 531.5 209 L 533 212.5 L 532 212.5 L 531.5 209 Z "
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 728.5 209 L 729 211.5 L 728 211.5 L 728.5 209 Z "
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 339.5 210 L 340 212.5 L 339 212.5 L 339.5 210 Z "
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 872.5 210 L 876 214.5 L 874 213.5 L 872.5 210 Z "
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 407.5 212 L 406.5 214 L 407.5 212 Z "
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 661.5 212 L 662 213.5 L 660.5 216 L 660 214.5 L 661.5 212 Z "
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 65.5 213 L 66 223.5 L 65 223.5 L 65.5 213 Z "
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 707.5 213 L 708 215.5 L 707 215.5 L 707.5 213 Z "
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 727.5 213 L 728 215.5 L 727 215.5 L 727.5 213 Z "
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 795.5 213 L 795 214.5 L 791.5 222 L 791 220.5 L 795.5 213 Z "
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 318.5 214 L 319 216.5 L 318 216.5 L 318.5 214 Z "
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 338.5 214 L 339 216.5 L 338 216.5 L 338.5 214 Z "
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 486.5 214 L 490 220.5 L 489 220.5 L 486.5 214 Z "
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 554.5 214 L 556 217.5 L 555 217.5 L 554.5 214 Z "
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 621.5 215 L 623 218.5 L 622 218.5 L 621.5 215 Z "
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1919.5 215 L 1920 220.5 L 1919 220.5 L 1919.5 215 Z "
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1136.5 216 L 1137 222.5 L 1136 222.5 L 1136.5 216 Z "
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 706.5 218 L 707 221.5 L 706 221.5 L 706.5 218 Z "
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 726.5 218 L 727 221.5 L 726 221.5 L 726.5 218 Z "
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 317.5 219 L 318 223.5 L 317 223.5 L 317.5 219 Z "
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 337.5 219 L 338 222.5 L 337 222.5 L 337.5 219 Z "
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 556.5 219 L 558 222.5 L 557 222.5 L 556.5 219 Z "
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 623.5 220 L 625 223.5 L 624 223.5 L 623.5 220 Z "
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 658.5 220 L 659 221.5 L 657.5 224 L 657 222.5 L 658.5 220 Z "
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 402.5 221 L 403 222.5 L 401.5 226 L 401 223.5 L 402.5 221 Z "
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 490.5 222 L 492 226.5 L 491 226.5 L 490.5 222 Z "
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 536.5 222 L 538 225.5 L 537 225.5 L 536.5 222 Z "
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 0.5 224 L 1 232.5 L 0 232.5 L 0.5 224 Z "
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 558.5 224 L 560 227.5 L 559 227.5 L 558.5 224 Z "
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 725.5 224 L 726 228.5 L 725 228.5 L 725.5 224 Z "
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 705.5 225 L 706 230.5 L 705 230.5 L 705.5 225 Z "
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 336.5 226 L 337 230.5 L 336 230.5 L 336.5 226 Z "
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 316.5 227 L 317 233.5 L 316 233.5 L 316.5 227 Z "
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 538.5 227 L 540 230.5 L 539 230.5 L 538.5 227 Z "
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1920.5 227 L 1921 256.5 L 1920 256.5 L 1920.5 227 Z "
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 66.5 228 L 67 232.5 L 66 232.5 L 66.5 228 Z "
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 492.5 228 L 493 230.5 L 492 230.5 L 492.5 228 Z "
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 626.5 228 L 628 231.5 L 627 231.5 L 626.5 228 Z "
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 655.5 228 L 656 229.5 L 654.5 232 L 654 230.5 L 655.5 228 Z "
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 881.5 229 L 882 231.5 L 881 231.5 L 881.5 229 Z "
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 788.5 230 L 789 232.5 L 788 232.5 L 788.5 230 Z "
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1135.5 230 L 1136 253.5 L 1135 253.5 L 1135.5 230 Z "
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 399.5 231 L 400 234.5 L 399 234.5 L 399.5 231 Z "
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 561.5 232 L 563 235.5 L 562 235.5 L 561.5 232 Z "
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 493.5 233 L 494 237.5 L 493 237.5 L 493.5 233 Z "
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 653.5 233 L 654 234.5 L 652.5 237 L 652 235.5 L 653.5 233 Z "
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 724.5 234 L 725 250.5 L 724 250.5 L 724.5 234 Z "
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 882.5 234 L 883 250.5 L 882 250.5 L 882.5 234 Z "
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 67.5 235 L 68 237.5 L 67 237.5 L 67.5 235 Z "
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 629.5 236 L 631 239.5 L 630 239.5 L 629.5 236 Z "
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 787.5 236 L 788 248.5 L 787 248.5 L 787.5 236 Z "
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1.5 237 L 2 240.5 L 1 240.5 L 1.5 237 Z "
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 563.5 237 L 565 240.5 L 564 240.5 L 563.5 237 Z "
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 68.5 239 L 69 241.5 L 68 241.5 L 68.5 239 Z "
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 398.5 240 L 399 245.5 L 398 245.5 L 398.5 240 Z "
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 543.5 240 L 545 243.5 L 544 243.5 L 543.5 240 Z "
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 217.5 241 L 224 241.5 L 217.5 242 L 217.5 241 Z "
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 335.5 241 L 336 243.5 L 335 243.5 L 335.5 241 Z "
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 650.5 241 L 651 242.5 L 649.5 245 L 649 243.5 L 650.5 241 Z "
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 211.5 242 L 214 242.5 L 211.5 243 L 211.5 242 Z "
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 227.5 242 L 230 242.5 L 227.5 243 L 227.5 242 Z "
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 565.5 242 L 567 245.5 L 566 245.5 L 565.5 242 Z "
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 208.5 243 L 210 243.5 L 206.5 245 L 206.5 244 L 208.5 243 Z "
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 231.5 243 L 238 246.5 L 236.5 246 L 231.5 244 L 231.5 243 Z "
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 2.5 244 L 3 246.5 L 2 246.5 L 2.5 244 Z "
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 632.5 244 L 634 247.5 L 633 247.5 L 632.5 244 Z "
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 545.5 245 L 547 248.5 L 546 248.5 L 545.5 245 Z "
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 70.5 246 L 72 249.5 L 71 249.5 L 70.5 246 Z "
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 202.5 246 L 201.5 248 L 202.5 246 Z "
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 239.5 247 L 246.5 255 L 239.5 247 Z "
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 493.5 247 L 494 251.5 L 493 251.5 L 493.5 247 Z "
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 199.5 248 L 193 255.5 L 191.5 258 L 192 256.5 L 199.5 248 Z "
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 3.5 249 L 4 251.5 L 3 251.5 L 3.5 249 Z "
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 647.5 249 L 648 250.5 L 646.5 253 L 646 251.5 L 647.5 249 Z "
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 568.5 250 L 570 253.5 L 569 253.5 L 568.5 250 Z "
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 316.5 251 L 317 257.5 L 316 257.5 L 316.5 251 Z "
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 399.5 251 L 400 254.5 L 399 254.5 L 399.5 251 Z "
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 635.5 252 L 637 255.5 L 636 255.5 L 635.5 252 Z "
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 788.5 252 L 789 255.5 L 788 255.5 L 788.5 252 Z "
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 881.5 253 L 882 256.5 L 881 256.5 L 881.5 253 Z "
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 4.5 254 L 5 256.5 L 4 256.5 L 4.5 254 Z "
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 336.5 254 L 337 259.5 L 336 259.5 L 336.5 254 Z "
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 705.5 254 L 706 259.5 L 705 259.5 L 705.5 254 Z "
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 492.5 255 L 493 257.5 L 492 257.5 L 492.5 255 Z "
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 570.5 255 L 572 258.5 L 571 258.5 L 570.5 255 Z "
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 247.5 256 L 250 260.5 L 249 260.5 L 247.5 256 Z "
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 400.5 256 L 401 258.5 L 400 258.5 L 400.5 256 Z "
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 725.5 256 L 726 260.5 L 725 260.5 L 725.5 256 Z "
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 75.5 257 Q 81.3 267.3 90 274.5 L 81 266.5 L 75.5 257 Z "
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 644.5 257 L 645 258.5 L 643.5 261 L 643 259.5 L 644.5 257 Z "
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 789.5 257 L 790 259.5 L 789 259.5 L 789.5 257 Z "
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 550.5 258 L 552 261.5 L 551 261.5 L 550.5 258 Z "
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 190.5 259 L 188.5 262 L 190.5 259 Z "
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 572.5 260 L 574 263.5 L 573 263.5 L 572.5 260 Z "
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 6.5 261 L 7 263.5 L 6 263.5 L 6.5 261 Z "
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 790.5 261 L 792 264.5 L 791 264.5 L 790.5 261 Z "
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 317.5 262 L 318 265.5 L 317 265.5 L 317.5 262 Z "
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 337.5 262 L 338 265.5 L 337 265.5 L 337.5 262 Z "
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1136.5 262 L 1137 267.5 L 1136 267.5 L 1136.5 262 Z "
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 187.5 263 L 174.5 277 L 168.5 281 L 169.5 279 Q 180.6 273.1 187.5 263 Z "
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 402.5 263 L 404 266.5 L 403 266.5 L 402.5 263 Z "
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 552.5 263 L 554 266.5 L 553 266.5 L 552.5 263 Z "
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 706.5 263 L 707 267.5 L 706 267.5 L 706.5 263 Z "
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 726.5 263 L 727 266.5 L 726 266.5 L 726.5 263 Z "
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 878.5 264 L 879 265.5 Q 873.8 277.8 863.5 285 L 853.5 290 L 853.5 289 Q 866.1 284.6 873 274.5 L 878.5 264 Z "
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1525.5 264 L 1531 264.5 L 1525.5 265 L 1525.5 264 Z "
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1919.5 264 L 1920 269.5 L 1919 269.5 L 1919.5 264 Z "
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 251.5 265 L 252 267.5 L 251 267.5 L 251.5 265 Z "
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1513.5 265 L 1518 265.5 L 1513.5 266 L 1513.5 265 Z "
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1538.5 265 L 1543 265.5 L 1538.5 266 L 1538.5 265 Z "
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1507.5 266 L 1511 266.5 L 1507.5 267 L 1507.5 266 Z "
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1545.5 266 L 1549 266.5 L 1545.5 267 L 1545.5 266 Z "
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1503.5 267 L 1506 267.5 L 1503.5 268 L 1503.5 267 Z "
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1550.5 267 L 1553 267.5 L 1550.5 268 L 1550.5 267 Z "
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 8.5 268 L 10 271.5 L 9 271.5 L 8.5 268 Z "
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 318.5 268 L 319 271.5 L 318 271.5 L 318.5 268 Z "
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 338.5 268 L 339 270.5 L 338 270.5 L 338.5 268 Z "
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 575.5 268 L 577 271.5 L 576 271.5 L 575.5 268 Z "
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1499.5 268 L 1502 268.5 L 1499.5 269 L 1499.5 268 Z "
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1554.5 268 L 1557 268.5 L 1554.5 269 L 1554.5 268 Z "
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 727.5 269 L 728 271.5 L 727 271.5 L 727.5 269 Z "
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 252.5 270 L 253 275.5 L 252 275.5 L 252.5 270 Z "
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 405.5 270 L 409 274.5 L 406 272.5 L 405.5 270 Z "
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 794.5 270 L 806 283.5 L 797 275.5 L 794.5 270 Z "
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 486.5 271 L 486 272.5 L 477.5 283 L 471.5 287 L 472.5 285 L 482 277.5 L 486.5 271 Z "
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 553.5 271 L 554 273.5 L 553 273.5 L 553.5 271 Z "
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1490.5 271 L 1492 271.5 L 1488.5 273 L 1488.5 272 L 1490.5 271 Z "
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1564.5 271 L 1568 272.5 L 1566.5 273 L 1564.5 271 Z "
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 339.5 272 L 340 274.5 L 339 274.5 L 339.5 272 Z "
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 704.5 272 L 705 273.5 L 703.5 276 L 703 274.5 L 704.5 272 Z "
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1137.5 272 L 1138 276.5 L 1137 276.5 L 1137.5 272 Z "
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 10.5 273 L 12 276.5 L 11 276.5 L 10.5 273 Z "
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 319.5 273 L 320 275.5 L 319 275.5 L 319.5 273 Z "
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 577.5 273 L 579 276.5 L 578 276.5 L 577.5 273 Z "
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 728.5 273 L 729 275.5 L 728 275.5 L 728.5 273 Z "
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1571.5 274 L 1576 276.5 L 1574.5 276 Q 1570.7 275.7 1571.5 274 Z "
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1918.5 274 L 1919 277.5 L 1918 277.5 L 1918.5 274 Z "
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 91.5 275 L 93.5 278 L 91.5 275 Z "
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 340.5 276 L 341 278.5 L 340 278.5 L 340.5 276 Z "
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 409.5 276 L 416.5 284 L 409.5 276 Z "
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 320.5 277 L 321 279.5 L 320 279.5 L 320.5 277 Z "
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 702.5 277 L 703 278.5 L 701.5 281 L 701 279.5 L 702.5 277 Z "
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1478.5 277 L 1477.5 279 L 1475.5 280 L 1476.5 278 L 1478.5 277 Z "
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 12.5 278 L 18 288.5 L 16 287.5 L 12 279.5 L 12.5 278 Z "
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 95.5 278 L 96.5 280 L 95.5 278 Z "
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 551.5 278 L 552 280.5 L 549.5 286 L 549 284.5 L 551.5 278 Z "
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 579.5 278 L 581 281.5 L 580 281.5 L 579.5 278 Z "
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1579.5 278 L 1583 280.5 L 1581.5 280 L 1579.5 278 Z "
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 251.5 279 L 252 281.5 L 251 281.5 L 251.5 279 Z "
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 98.5 280 L 107 284.5 L 105.5 285 L 99.5 282 L 98.5 280 Z "
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1138.5 280 L 1139 283.5 L 1138 283.5 L 1138.5 280 Z "
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1473.5 280 L 1472.5 282 L 1469.5 284 L 1471.5 281 L 1473.5 280 Z "
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 166.5 281 L 165.5 283 L 163.5 284 L 164.5 282 L 166.5 281 Z "
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 321.5 281 L 322 283.5 L 321 283.5 L 321.5 281 Z "
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1584.5 281 L 1591 286.5 L 1587.5 284 L 1584.5 281 Z "
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1917.5 281 L 1918 284.5 L 1917 284.5 L 1917.5 281 Z "
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 342.5 283 L 344 286.5 L 343 286.5 L 342.5 283 Z "
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 418.5 284 L 419.5 286 L 418.5 284 Z "
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 807.5 284 L 808.5 286 L 807.5 284 Z "
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1467.5 284 L 1464.5 288 L 1467.5 284 Z "
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 158.5 285 L 160 285.5 L 155.5 287 L 155.5 286 L 158.5 285 Z "
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 421.5 286 L 428 289.5 L 426.5 290 Q 421.9 288.8 421.5 286 Z "
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 582.5 286 L 584 289.5 L 583 289.5 L 582.5 286 Z "
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 732.5 286 L 734 289.5 L 733 289.5 L 732.5 286 Z "
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 810.5 286 L 817 289.5 L 815.5 290 Q 810.9 288.8 810.5 286 Z "
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1139.5 286 L 1140 288.5 L 1139 288.5 L 1139.5 286 Z "
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 113.5 287 L 116 287.5 L 113.5 288 L 113.5 287 Z "
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 548.5 287 L 549 288.5 L 547.5 291 L 547 289.5 L 548.5 287 Z "
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1592.5 287 L 1602.5 298 L 1592.5 287 Z "
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1916.5 287 L 1917 289.5 L 1916 289.5 L 1916.5 287 Z "
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 117.5 288 L 120 288.5 L 117.5 289 L 117.5 288 Z "
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 147.5 288 L 150 288.5 L 147.5 289 L 147.5 288 Z "
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 344.5 288 L 346 291.5 L 345 291.5 L 344.5 288 Z "
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1462.5 288 L 1454.5 297 L 1462.5 288 Z "
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 123.5 289 L 128 289.5 L 123.5 290 L 123.5 289 Z "
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 139.5 289 L 145 289.5 L 139.5 290 L 139.5 289 Z "
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 464.5 289 L 466 289.5 L 462.5 291 L 462.5 290 L 464.5 289 Z "
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 18.5 290 L 21 293.5 L 19 292.5 L 18.5 290 Z "
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 247.5 290 L 247 291.5 Q 237.3 308.8 222.5 321 L 235 307.5 L 247.5 290 Z "
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 697.5 290 L 698 291.5 L 696.5 294 L 696 292.5 L 697.5 290 Z "
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 324.5 291 L 326 294.5 L 325 294.5 L 324.5 291 Z "
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 432.5 291 L 435 291.5 L 432.5 292 L 432.5 291 Z "
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 458.5 291 L 461 291.5 L 458.5 292 L 458.5 291 Z "
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 584.5 291 L 586 294.5 L 585 294.5 L 584.5 291 Z "
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 821.5 291 L 824 291.5 L 821.5 292 L 821.5 291 Z "
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 846.5 291 L 849 291.5 L 846.5 292 L 846.5 291 Z "
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1140.5 291 L 1141 293.5 L 1140 293.5 L 1140.5 291 Z "
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 436.5 292 L 440 292.5 L 436.5 293 L 436.5 292 Z "
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 452.5 292 L 456 292.5 L 452.5 293 L 452.5 292 Z "
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 826.5 292 L 830 292.5 L 826.5 293 L 826.5 292 Z "
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 840.5 292 L 845 292.5 L 840.5 293 L 840.5 292 Z "
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1915.5 292 L 1916 294.5 L 1915 294.5 L 1915.5 292 Z "
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 735.5 293 L 738 297.5 L 736 296.5 L 735.5 293 Z "
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 545.5 294 L 546 295.5 L 544 296.5 L 545.5 294 Z "
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 21.5 295 L 22.5 297 L 21.5 295 Z "
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 695.5 295 L 696 296.5 L 694.5 299 L 694 297.5 L 695.5 295 Z "
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 586.5 296 L 588 299.5 L 587 299.5 L 586.5 296 Z "
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1141.5 296 L 1142 298.5 L 1141 298.5 L 1141.5 296 Z "
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1914.5 297 L 1915 299.5 L 1914 299.5 L 1914.5 297 Z "
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 23.5 298 L 24.5 300 L 23.5 298 Z "
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 327.5 298 L 334 310.5 L 332 309.5 L 327 299.5 L 327.5 298 Z "
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1453.5 298 L 1450.5 302 L 1453.5 298 Z "
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 349.5 299 L 352 302.5 L 350 301.5 L 349.5 299 Z "
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1603.5 299 L 1609 305.5 L 1606 303.5 L 1603.5 299 Z "
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 542.5 300 L 542 301.5 L 540.5 304 L 541 302.5 L 542.5 300 Z "
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1142.5 300 L 1143 302.5 L 1142 302.5 L 1142.5 300 Z "
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 25.5 301 L 40 317.5 L 34 312.5 L 25.5 301 Z "
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 739.5 301 Q 748.4 316.6 762 327.5 L 747 313.5 L 739.5 301 Z "
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1913.5 301 L 1914 303.5 L 1913 303.5 L 1913.5 301 Z "
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1449.5 303 L 1448 305.5 L 1446.5 308 L 1447 306.5 L 1449.5 303 Z "
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 352.5 304 L 356 308.5 L 353 306.5 L 352.5 304 Z "
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 589.5 304 L 591 307.5 L 590 307.5 L 589.5 304 Z "
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1143.5 304 L 1144 306.5 L 1143 306.5 L 1143.5 304 Z "
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 539.5 305 L 538.5 307 L 539.5 305 Z "
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1912.5 305 L 1913 307.5 L 1912 307.5 L 1912.5 305 Z "
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1609.5 307 L 1612 310.5 L 1610 309.5 L 1609.5 307 Z "
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 537.5 308 L 536 310.5 L 522.5 326 L 531 316.5 L 537.5 308 Z "
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 690.5 308 L 691 309.5 L 689.5 312 L 689 310.5 L 690.5 308 Z "
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1144.5 308 L 1146 313.5 L 1145 313.5 L 1144.5 308 Z "
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 591.5 309 L 593 312.5 L 592 312.5 L 591.5 309 Z "
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1445.5 309 L 1445 310.5 L 1443.5 313 L 1444 311.5 L 1445.5 309 Z "
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 356.5 310 L 373 327.5 L 359 314.5 L 356.5 310 Z "
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 334.5 312 L 336 314.5 L 335 314.5 L 334.5 312 Z "
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1612.5 312 L 1617 320.5 L 1616 320.5 L 1612.5 312 Z "
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 688.5 313 L 689 314.5 L 687.5 317 L 687 315.5 L 688.5 313 Z "
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 593.5 314 L 595 317.5 L 594 317.5 L 593.5 314 Z "
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1909.5 315 L 1910 317.5 L 1907.5 323 L 1907 321.5 L 1909.5 315 Z "
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 41.5 318 L 46.5 324 L 41.5 318 Z "
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 686.5 318 L 687 319.5 L 685.5 322 L 685 320.5 L 686.5 318 Z "
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1439.5 320 L 1440 321.5 L 1438.5 324 L 1438 322.5 L 1439.5 320 Z "
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 220.5 321 L 217.5 325 L 220.5 321 Z "
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 684.5 323 L 685 324.5 L 682.5 328 L 683 326.5 L 684.5 323 Z "
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 48.5 324 L 60 332.5 L 58.5 332 Q 51 329.3 48.5 324 Z "
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 597.5 324 L 599 326.5 L 597 325.5 L 597.5 324 Z "
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1149.5 324 L 1151 327.5 L 1150 327.5 L 1149.5 324 Z "
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 215.5 325 L 213.5 328 L 210.5 330 L 212.5 327 L 215.5 325 Z "
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 335.5 325 L 336 327.5 L 335 327.5 L 335.5 325 Z "
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 976.5 325 L 977 327.5 L 976 327.5 L 976.5 325 Z "
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1437.5 325 L 1438 326.5 L 1435.5 333 L 1435 330.5 L 1437.5 325 Z "
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 273.5 326 L 274 328.5 L 273 328.5 L 273.5 326 Z "
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 520.5 326 L 517.5 330 L 520.5 326 Z "
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1038.5 327 L 1039 329.5 L 1038 329.5 L 1038.5 327 Z "
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1905.5 327 L 1906 328.5 L 1904.5 331 L 1904 329.5 L 1905.5 327 Z "
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 374.5 328 L 376.5 331 L 374.5 328 Z "
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 599.5 328 L 611 341.5 L 602 333.5 L 599.5 328 Z "
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 763.5 328 L 775 336.5 L 773.5 336 Q 766 333.3 763.5 328 Z "
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 334.5 329 L 335 331.5 L 326.5 344 L 328 341.5 L 334.5 329 Z "
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 681.5 329 L 681 330.5 L 677.5 335 L 680 331.5 L 681.5 329 Z "
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 977.5 329 Q 979.9 338.1 986 343.5 L 983 341.5 L 977 331.5 L 977.5 329 Z "
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1151.5 329 L 1153 332.5 L 1152 332.5 L 1151.5 329 Z "
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 208.5 330 L 207.5 332 L 205.5 333 L 206.5 331 L 208.5 330 Z "
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 274.5 330 L 276 333.5 L 275 333.5 L 274.5 330 Z "
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 515.5 330 L 513.5 333 L 508.5 336 L 509.5 334 L 515.5 330 Z "
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 378.5 331 L 386 336.5 L 384.5 336 Q 379.5 334.5 378.5 331 Z "
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1037.5 331 L 1038 332.5 Q 1034.4 340.9 1027.5 346 L 1019.5 350 L 1019.5 349 Q 1028.2 346.2 1033 339.5 L 1037.5 331 Z "
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1903.5 332 L 1904 333.5 L 1902.5 336 L 1902 334.5 L 1903.5 332 Z "
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 61.5 333 L 65 335.5 L 63.5 335 L 61.5 333 Z "
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 203.5 333 L 202.5 335 L 198.5 337 L 199.5 335 L 203.5 333 Z "
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1621.5 333 L 1622 335.5 L 1621 335.5 L 1621.5 333 Z "
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 952.5 334 L 953 335.5 L 951 336.5 L 952.5 334 Z "
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1153.5 334 L 1155 337.5 L 1154 337.5 L 1153.5 334 Z "
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1434.5 334 L 1435 336.5 L 1434 336.5 L 1434.5 334 Z "
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 276.5 335 L 280 339.5 L 277 337.5 L 276.5 335 Z "
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 896.5 335 Q 899.8 333.9 899 336.5 L 899.5 338 L 896.5 336 L 895 336.5 L 896.5 335 Z "
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 506.5 336 L 505.5 338 L 503.5 339 L 504.5 337 L 506.5 336 Z "
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 676.5 336 L 672.5 341 L 658.5 349 L 658.5 348 Q 669.7 344.3 676.5 336 Z "
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 893.5 337 L 892.5 339 L 885.5 342 L 885.5 341 L 893.5 337 Z "
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1622.5 337 L 1623 340.5 L 1622 340.5 L 1622.5 337 Z "
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 193.5 338 L 195 338.5 L 189.5 341 L 189.5 340 L 193.5 338 Z "
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 950.5 338 L 949 340.5 L 945.5 345 L 948 341.5 L 950.5 338 Z "
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1433.5 338 L 1434 341.5 L 1433 341.5 L 1433.5 338 Z "
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 72.5 339 L 78 341.5 L 76.5 342 L 72.5 340 L 72.5 339 Z "
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 900.5 339 L 907.5 347 L 900.5 339 Z "
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 186.5 341 L 188 341.5 L 184.5 343 L 184.5 342 L 186.5 341 Z "
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 280.5 341 L 287 346.5 L 284.5 345 L 280.5 341 Z "
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 496.5 341 L 498 341.5 L 494.5 343 L 494.5 342 L 496.5 341 Z "
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1899.5 341 L 1900 342.5 L 1894.5 352 L 1895 350.5 L 1899.5 341 Z "
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 397.5 342 L 401 343.5 L 399.5 344 L 397.5 342 Z "
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 612.5 342 L 617 345.5 L 615.5 345 L 612.5 342 Z "
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 786.5 342 L 790 343.5 L 788.5 344 L 786.5 342 Z "
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 882.5 342 L 884 342.5 L 880.5 344 L 880.5 343 L 882.5 342 Z "
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 82.5 343 L 90 345.5 L 87.5 346 L 82.5 344 L 82.5 343 Z "
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 491.5 343 L 493 343.5 L 489.5 345 L 489.5 344 L 491.5 343 Z "
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1623.5 343 L 1624 346.5 L 1623 346.5 L 1623.5 343 Z "
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 324.5 344 L 322.5 347 L 324.5 344 Z "
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 987.5 344 L 989.5 347 L 987.5 344 Z "
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1432.5 344 L 1433 348.5 L 1432 348.5 L 1432.5 344 Z "
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 943.5 345 L 941.5 348 L 936.5 350 L 936.5 349 L 943.5 345 Z "
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 171.5 346 L 174 346.5 L 171.5 347 L 171.5 346 Z "
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 94.5 347 L 97 347.5 L 94.5 348 L 94.5 347 Z "
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 167.5 347 L 170 347.5 L 167.5 348 L 167.5 347 Z "
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 288.5 347 L 293 349.5 L 291.5 350 L 288.5 347 Z "
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 320.5 347 L 319.5 349 L 316.5 350 L 316.5 349 L 320.5 347 Z "
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 411.5 347 L 414 347.5 L 411.5 348 L 411.5 347 Z "
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 479.5 347 L 482 347.5 L 479.5 348 L 479.5 347 Z "
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 800.5 347 L 803 347.5 L 800.5 348 L 800.5 347 Z "
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 867.5 347 L 870 347.5 L 867.5 348 L 867.5 347 Z "
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 909.5 347 L 914 349.5 L 912.5 350 L 909.5 347 Z "
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 991.5 347 L 994 348.5 L 992.5 349 L 991.5 347 Z "
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 98.5 348 L 101 348.5 L 98.5 349 L 98.5 348 Z "
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 163.5 348 L 166 348.5 L 163.5 349 L 163.5 348 Z "
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 415.5 348 L 418 348.5 L 415.5 349 L 415.5 348 Z "
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 475.5 348 L 478 348.5 L 475.5 349 L 475.5 348 Z "
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 804.5 348 L 807 348.5 L 804.5 349 L 804.5 348 Z "
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 863.5 348 L 866 348.5 L 863.5 349 L 863.5 348 Z "
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 103.5 349 L 107 349.5 L 103.5 350 L 103.5 349 Z "
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 157.5 349 L 161 349.5 L 157.5 350 L 157.5 349 Z "
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 419.5 349 L 423 349.5 L 419.5 350 L 419.5 349 Z "
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 470.5 349 L 473 349.5 L 470.5 350 L 470.5 349 Z "
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 809.5 349 L 812 349.5 L 809.5 350 L 809.5 349 Z "
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 858.5 349 L 862 349.5 L 858.5 350 L 858.5 349 Z "
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 109.5 350 L 114 350.5 L 109.5 351 L 109.5 350 Z "
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 150.5 350 L 155 350.5 L 150.5 351 L 150.5 350 Z "
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 425.5 350 L 429 350.5 L 425.5 351 L 425.5 350 Z "
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 464.5 350 L 468 350.5 L 464.5 351 L 464.5 350 Z "
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 628.5 350 L 631 350.5 L 628.5 351 L 628.5 350 Z "
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 651.5 350 L 654 350.5 L 651.5 351 L 651.5 350 Z "
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 814.5 350 L 819 350.5 L 814.5 351 L 814.5 350 Z "
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 852.5 350 L 856 350.5 L 852.5 351 L 852.5 350 Z "
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 997.5 350 L 1000 350.5 L 997.5 351 L 997.5 350 Z "
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 118.5 351 L 126 351.5 L 118.5 352 L 118.5 351 Z "
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 134.5 351 L 143 351.5 L 134.5 352 L 134.5 351 Z "
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 298.5 351 L 302 351.5 L 298.5 352 L 298.5 351 Z "
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 307.5 351 L 311 351.5 L 307.5 352 L 307.5 351 Z "
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 433.5 351 L 441 351.5 L 433.5 352 L 433.5 351 Z "
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 452.5 351 L 460 351.5 L 452.5 352 L 452.5 351 Z "
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 633.5 351 L 638 351.5 L 633.5 352 L 633.5 351 Z "
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 644.5 351 L 649 351.5 L 644.5 352 L 644.5 351 Z "
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 823.5 351 L 833 351.5 L 823.5 352 L 823.5 351 Z "
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 837.5 351 L 848 351.5 L 837.5 352 L 837.5 351 Z "
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 919.5 351 L 923 351.5 L 919.5 352 L 919.5 351 Z "
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 928.5 351 L 932 351.5 L 928.5 352 L 928.5 351 Z "
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1001.5 351 L 1005 351.5 L 1001.5 352 L 1001.5 351 Z "
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1010.5 351 L 1014 351.5 L 1010.5 352 L 1010.5 351 Z "
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1624.5 352 L 1625 362.5 L 1624 362.5 L 1624.5 352 Z "
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1162.5 353 L 1165 356.5 L 1163 355.5 L 1162.5 353 Z "
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1892.5 355 L 1892 356.5 L 1890.5 359 L 1891 357.5 L 1892.5 355 Z "
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1165.5 358 L 1168 361.5 L 1166 360.5 L 1165.5 358 Z "
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1889.5 360 L 1889 361.5 L 1887.5 364 L 1888 362.5 L 1889.5 360 Z "
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1168.5 363 L 1174 370.5 L 1171 368.5 L 1168.5 363 Z "
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1886.5 365 L 1885.5 367 L 1886.5 365 Z "
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1432.5 367 L 1433 371.5 L 1432 371.5 L 1432.5 367 Z "
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1623.5 368 L 1624 372.5 L 1623 372.5 L 1623.5 368 Z "
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1884.5 368 L 1883 370.5 L 1880.5 374 L 1882 371.5 L 1884.5 368 Z "
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1174.5 372 L 1184 383.5 L 1179 379.5 L 1174.5 372 Z "
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1433.5 374 L 1434 376.5 L 1433 376.5 L 1433.5 374 Z "
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1622.5 375 L 1623 377.5 L 1622 377.5 L 1622.5 375 Z "
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1879.5 375 L 1877.5 378 L 1879.5 375 Z "
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1434.5 379 L 1435 381.5 L 1434 381.5 L 1434.5 379 Z "
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1621.5 379 L 1622 381.5 L 1621 381.5 L 1621.5 379 Z "
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1876.5 379 L 1873.5 383 L 1876.5 379 Z "
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1620.5 383 L 1621 385.5 L 1618.5 391 L 1618 389.5 L 1620.5 383 Z "
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1872.5 384 L 1864.5 393 L 1872.5 384 Z "
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1184.5 385 L 1211 410.5 L 1206.5 407 L 1184.5 385 Z "
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1438.5 392 L 1440 395.5 L 1439 395.5 L 1438.5 392 Z "
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1863.5 394 L 1859.5 399 L 1863.5 394 Z "
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1616.5 395 L 1617 396.5 L 1615.5 399 L 1615 397.5 L 1616.5 395 Z "
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1440.5 397 L 1442 400.5 L 1441 400.5 L 1440.5 397 Z "
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1857.5 399 L 1849.5 408 L 1844.5 412 L 1848.5 407 L 1857.5 399 Z "
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1614.5 400 L 1615 401.5 L 1613.5 404 L 1613 402.5 L 1614.5 400 Z "
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1443.5 405 L 1445 408.5 L 1444 408.5 L 1443.5 405 Z "
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1611.5 408 L 1612 409.5 L 1610.5 412 L 1610 410.5 L 1611.5 408 Z "
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1445.5 410 L 1447 413.5 L 1446 413.5 L 1445.5 410 Z "
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1212.5 411 L 1219 416.5 L 1216.5 415 L 1212.5 411 Z "
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1842.5 412 L 1840.5 415 L 1842.5 412 Z "
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1609.5 413 L 1610 414.5 L 1608.5 417 L 1608 415.5 L 1609.5 413 Z "
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1838.5 415 L 1836.5 418 L 1825.5 425 L 1826.5 423 L 1838.5 415 Z "
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1220.5 417 L 1228 422.5 L 1226.5 422 Q 1221.5 420.5 1220.5 417 Z "
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1229.5 423 L 1233 425.5 L 1231.5 425 L 1229.5 423 Z "
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1450.5 423 L 1452 426.5 L 1451 426.5 L 1450.5 423 Z "
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1823.5 425 L 1822.5 427 L 1820.5 428 L 1821.5 426 L 1823.5 425 Z "
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1234.5 426 L 1238 428.5 L 1236.5 428 L 1234.5 426 Z "
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1604.5 426 L 1605 427.5 L 1603.5 430 L 1603 428.5 L 1604.5 426 Z "
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1452.5 428 L 1454 431.5 L 1453 431.5 L 1452.5 428 Z "
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1814.5 430 L 1813.5 432 L 1806.5 435 L 1806.5 434 L 1814.5 430 Z "
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1602.5 431 L 1603 432.5 L 1601.5 435 L 1601 433.5 L 1602.5 431 Z "
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1253.5 436 L 1259 438.5 L 1257.5 439 L 1253.5 437 L 1253.5 436 Z "
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1605.5 436 L 1611 438.5 L 1609.5 439 L 1605.5 437 L 1605.5 436 Z "
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1447.5 437 L 1449 437.5 L 1445.5 439 L 1445.5 438 L 1447.5 437 Z "
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1799.5 437 L 1801 437.5 L 1797.5 439 L 1797.5 438 L 1799.5 437 Z "
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1260.5 439 L 1264 440.5 L 1262.5 441 L 1260.5 439 Z "
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1442.5 439 L 1444 439.5 L 1440.5 441 L 1440.5 440 L 1442.5 439 Z "
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1612.5 439 L 1616 440.5 L 1614.5 441 L 1612.5 439 Z "
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1794.5 439 L 1796 439.5 L 1792.5 441 L 1792.5 440 L 1794.5 439 Z "
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1789.5 441 L 1791 441.5 L 1777.5 446 L 1777.5 445 L 1789.5 441 Z "
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1268.5 442 L 1279 445.5 L 1276.5 446 L 1268.5 443 L 1268.5 442 Z "
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1434.5 442 L 1436 442.5 L 1425.5 446 L 1425.5 445 L 1434.5 442 Z "
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1620.5 442 L 1628 444.5 L 1625.5 445 L 1620.5 443 L 1620.5 442 Z "
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1283.5 447 L 1286 447.5 L 1283.5 448 L 1283.5 447 Z "
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1418.5 447 L 1421 447.5 L 1418.5 448 L 1418.5 447 Z "
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1635.5 447 L 1638 447.5 L 1635.5 448 L 1635.5 447 Z "
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1770.5 447 L 1773 447.5 L 1770.5 448 L 1770.5 447 Z "
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1287.5 448 L 1290 448.5 L 1287.5 449 L 1287.5 448 Z "
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1639.5 448 L 1642 448.5 L 1639.5 449 L 1639.5 448 Z "
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1291.5 449 L 1294 449.5 L 1291.5 450 L 1291.5 449 Z "
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1643.5 449 L 1646 449.5 L 1643.5 450 L 1643.5 449 Z "
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1295.5 450 L 1298 450.5 L 1295.5 451 L 1295.5 450 Z "
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1406.5 450 L 1409 450.5 L 1406.5 451 L 1406.5 450 Z "
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1647.5 450 L 1650 450.5 L 1647.5 451 L 1647.5 450 Z "
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1758.5 450 L 1761 450.5 L 1758.5 451 L 1758.5 450 Z "
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1300.5 451 L 1303 451.5 L 1300.5 452 L 1300.5 451 Z "
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1401.5 451 L 1404 451.5 L 1401.5 452 L 1401.5 451 Z "
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1652.5 451 L 1655 451.5 L 1652.5 452 L 1652.5 451 Z "
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1753.5 451 L 1756 451.5 L 1753.5 452 L 1753.5 451 Z "
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1305.5 452 L 1308 452.5 L 1305.5 453 L 1305.5 452 Z "
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1396.5 452 L 1399 452.5 L 1396.5 453 L 1396.5 452 Z "
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1657.5 452 L 1660 452.5 L 1657.5 453 L 1657.5 452 Z "
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1748.5 452 L 1751 452.5 L 1748.5 453 L 1748.5 452 Z "
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1311.5 453 L 1315 453.5 L 1311.5 454 L 1311.5 453 Z "
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1389.5 453 L 1393 453.5 L 1389.5 454 L 1389.5 453 Z "
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1663.5 453 L 1667 453.5 L 1663.5 454 L 1663.5 453 Z "
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1741.5 453 L 1745 453.5 L 1741.5 454 L 1741.5 453 Z "
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1318.5 454 L 1323 454.5 L 1318.5 455 L 1318.5 454 Z "
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1381.5 454 L 1386 454.5 L 1381.5 455 L 1381.5 454 Z "
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1670.5 454 L 1675 454.5 L 1670.5 455 L 1670.5 454 Z "
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1733.5 454 L 1738 454.5 L 1733.5 455 L 1733.5 454 Z "
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1327.5 455 L 1334 455.5 L 1327.5 456 L 1327.5 455 Z "
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1370.5 455 L 1377 455.5 L 1370.5 456 L 1370.5 455 Z "
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1679.5 455 L 1686 455.5 L 1679.5 456 L 1679.5 455 Z "
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1722.5 455 L 1729 455.5 L 1722.5 456 L 1722.5 455 Z "
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1344.5 456 L 1360 456.5 L 1344.5 457 L 1344.5 456 Z "
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,86,208)",
    stroke: "rgb(48,86,208)",
    strokeWidth: 1,
    opacity: 0.48627450980392156,
    d: "M 1696.5 456 L 1712 456.5 L 1696.5 457 L 1696.5 456 Z "
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,87,209)",
    stroke: "rgb(48,87,209)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1224.5 65 L 1245 69 L 1232 84.5 Q 1229 87.5 1230 94.5 L 1235.5 99 L 1249.5 102 L 1268.5 103 L 1269.5 104 L 1287.5 104 L 1288.5 105 L 1317 105.5 Q 1311.6 108.6 1313 118.5 L 1316.5 122 L 1321.5 123 L 1363.5 124 L 1364.5 123 L 1383.5 123 L 1384.5 122 L 1405.5 121 L 1406.5 120 L 1420.5 119 L 1447.5 114 L 1478.5 105 L 1501.5 94 L 1511.5 94 L 1521 101.5 L 1528.5 111 L 1539.5 97 Q 1544 92.5 1554.5 94 L 1580.5 106 L 1596.5 111 L 1623.5 117 L 1641.5 119 L 1642.5 120 L 1659.5 121 L 1660.5 122 L 1672.5 122 L 1673.5 123 L 1721.5 124 L 1722.5 123 L 1739.5 122 L 1743 118.5 L 1743 111.5 L 1739 104.5 L 1740.5 105 L 1767.5 105 L 1768.5 104 L 1798.5 103 L 1799.5 102 L 1817.5 100 Q 1823.3 98.8 1826 94.5 L 1826 87.5 L 1811 69 L 1831.5 65 Q 1850.4 76.6 1865 92.5 Q 1895 123.5 1910 169.5 L 1915 188.5 L 1919 211.5 L 1919 220.5 L 1920 221.5 L 1920 263.5 L 1919 264.5 L 1919 273.5 L 1915 296.5 L 1902 336.5 Q 1885.7 373.2 1858.5 399 Q 1824.9 431.9 1773.5 447 L 1747.5 453 L 1733.5 454 L 1732.5 455 L 1722.5 455 L 1721.5 456 L 1686.5 456 L 1685.5 455 L 1675.5 455 L 1674.5 454 L 1660.5 453 L 1634.5 447 L 1602 435 L 1621 385.5 L 1624 372.5 L 1625 352.5 L 1624 351.5 L 1623 337.5 L 1617 319.5 Q 1608 300 1592.5 287 Q 1580.9 277.1 1565.5 271 L 1548.5 266 L 1525.5 264 L 1524.5 265 L 1507.5 266 L 1490.5 271 Q 1468.4 279.9 1454 296.5 Q 1442.6 309.6 1436 327.5 L 1432 344.5 L 1432 356.5 L 1431 358.5 L 1432 359.5 L 1432 371.5 L 1434 381.5 L 1454 435 L 1421.5 447 L 1395.5 453 L 1381.5 454 L 1380.5 455 L 1370.5 455 L 1369.5 456 L 1334.5 456 L 1333.5 455 L 1323.5 455 L 1322.5 454 L 1315.5 454 L 1298.5 451 L 1282.5 447 L 1252.5 436 Q 1211.5 417 1184 384.5 Q 1159 355.5 1146 314.5 L 1141 295.5 L 1138 279.5 L 1138 272.5 L 1137 271.5 L 1137 262.5 L 1136 261.5 L 1136 223.5 L 1137 222.5 L 1137 212.5 L 1142 184.5 L 1155 146.5 Q 1173.8 105.3 1206.5 78 L 1224.5 65 Z M 1339 144 L 1325 147 L 1311 152 L 1292 164 Q 1275 177 1266 199 L 1261 214 L 1259 224 L 1259 231 L 1258 232 L 1258 254 L 1263 279 Q 1270 301 1285 316 Q 1297 328 1314 335 L 1330 340 L 1341 341 L 1342 342 L 1363 342 L 1379 339 Q 1401 333 1416 319 Q 1428 308 1436 292 L 1442 276 L 1446 255 L 1446 230 L 1442 210 Q 1436 190 1425 177 Q 1412 160 1392 151 L 1377 146 L 1366 144 L 1339 144 Z M 1691 144 L 1677 147 L 1663 152 L 1644 164 Q 1627 177 1618 199 L 1613 214 L 1611 224 L 1611 231 L 1610 232 Q 1608 282 1631 309 Q 1641 321 1656 330 L 1678 339 L 1694 342 L 1715 342 L 1731 339 Q 1753 333 1768 319 Q 1780 308 1788 292 L 1794 276 L 1798 255 L 1798 230 L 1794 210 Q 1788 190 1777 177 Q 1764 160 1744 151 L 1729 146 L 1718 144 L 1691 144 Z "
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,87,209)",
    stroke: "rgb(48,87,209)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 117.5 85 L 146.5 85 Q 148.3 87.8 154.5 86 L 183.5 94 Q 216.4 107.1 238 131.5 L 251 153.5 L 252 168.5 Q 249.5 180.5 241.5 187 Q 233.1 196.1 213.5 194 Q 202.6 191.4 196 184.5 Q 188.2 170.8 176.5 161 Q 168 153.5 156.5 149 L 141.5 146 L 125.5 146 L 108.5 150 Q 94 156 84 166.5 Q 64.8 185.3 65 223.5 L 66 224.5 L 67 237.5 L 70 247.5 Q 76.7 264.3 89.5 275 Q 99.4 283.6 113.5 288 L 123.5 290 L 144.5 290 Q 173.5 284 188 263.5 Q 192.6 254.1 200.5 248 L 214.5 242 L 226.5 242 Q 240.3 245.3 247 255.5 L 252 268.5 L 252 278.5 Q 242 305 221.5 321 Q 202.3 337.8 174.5 346 L 149.5 351 L 126.5 352 L 125.5 351 L 114.5 351 L 113.5 350 L 101.5 349 L 71.5 339 Q 50.3 328.7 35 312.5 Q 17.4 294.1 8 267.5 L 2 243.5 L 0 213.5 L 1 212.5 L 1 201.5 L 4 185.5 L 12 161.5 Q 24 133 45.5 114 Q 58.4 103.4 74.5 96 L 91.5 90 L 117.5 85 Z "
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,87,209)",
    stroke: "rgb(48,87,209)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 298.5 85 L 314.5 86 Q 324.5 89.5 330 97.5 L 336 111.5 L 336 170.5 Q 324.3 186.8 319 209.5 L 317 219.5 L 317 226.5 L 316 227.5 L 316 257.5 L 321 283.5 Q 326.4 301.6 336 315.5 L 336 324.5 Q 333.5 337 325.5 344 Q 317.7 351.7 302.5 352 Q 301.2 349.8 296.5 351 L 287.5 347 L 280 340.5 Q 274.9 334.7 273 325.5 L 273 111.5 Q 275.9 96.9 286.5 90 L 298.5 85 Z "
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,87,209)",
    stroke: "rgb(48,87,209)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1001.5 85 Q 1013.6 83.4 1020.5 87 L 1032 95.5 L 1039 109.5 L 1039 123.5 Q 1035.3 136.3 1025.5 143 L 1012.5 148 L 1002.5 148 Q 988.9 145.1 982 135.5 L 977 125.5 L 976 111.5 Q 979.1 97.1 989.5 90 L 1001.5 85 Z "
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,87,209)",
    stroke: "rgb(48,87,209)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 434.5 134 L 458.5 134 L 480.5 138 Q 503.1 143.9 518 157.5 Q 516.3 170.2 519 178.5 L 554 267.5 L 554 270.5 Q 545.4 305.9 521.5 326 Q 505.6 340.1 482.5 347 L 463.5 351 L 441.5 352 L 440.5 351 L 429.5 351 L 418.5 349 L 396.5 342 Q 374.4 332.1 360 314.5 Q 347.5 300 341 279.5 L 336 253.5 L 336 231.5 L 337 230.5 L 338 217.5 L 344 197.5 Q 353.3 175.8 369.5 161 Q 380.7 150.7 395.5 144 L 408.5 139 L 434.5 134 Z M 445 192 L 429 195 L 418 201 Q 406 209 401 224 L 398 241 L 400 259 L 409 277 Q 418 289 437 293 L 456 293 L 461 292 L 478 283 Q 491 272 494 252 L 494 234 L 493 229 Q 490 217 484 210 Q 472 193 445 192 Z "
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,87,209)",
    stroke: "rgb(48,87,209)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 563.5 134 Q 586.8 133.2 595 147.5 L 638 261 L 641.5 262 L 644 261 L 683 155.5 Q 686.8 144.8 695.5 139 L 707.5 134 L 718.5 134 Q 732.3 137.3 739 147.5 L 740 150.5 Q 718.6 171.6 709 204.5 L 705 225.5 L 705 259.5 L 706 260.5 L 706 268.5 L 685 322.5 Q 680.4 332.9 672.5 340 Q 661 351.5 638.5 352 L 627.5 350 L 617.5 346 L 603 333.5 L 596 321.5 L 540 177.5 L 538 170.5 L 538 159.5 Q 540.3 148.3 547.5 142 Q 553.5 136 563.5 134 Z "
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,87,209)",
    stroke: "rgb(48,87,209)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 821.5 134 L 848.5 134 L 849.5 135 L 861.5 136 L 881.5 142 L 896.5 150 L 899 150 Q 901.1 143.1 907.5 139 L 918.5 134 L 931.5 134 Q 943.7 137.3 950 146.5 L 955 158.5 L 955 327.5 Q 952.3 338.8 944.5 345 Q 937 351.5 923.5 352 Q 922.3 349.8 917.5 351 L 908.5 347 L 900 338.5 L 899 335 L 870.5 347 L 851.5 351 Q 840.6 349.6 833.5 352 L 832.5 351 L 819.5 351 L 818.5 350 L 807.5 349 L 785.5 342 Q 762.7 331.8 748 313.5 Q 735.3 298.2 729 276.5 L 725 255.5 L 725 229.5 L 729 208.5 L 738 186.5 Q 746.9 170.4 760.5 159 Q 772.6 148.6 788.5 142 L 808.5 136 L 820.5 135 L 821.5 134 Z M 832 192 L 821 194 L 813 197 L 803 204 Q 795 211 791 221 L 787 237 L 787 249 L 789 260 L 797 276 Q 807 289 827 293 L 845 293 Q 856 291 864 285 L 876 272 L 882 257 Q 881 252 883 251 L 883 235 L 881 226 L 872 209 Q 860 192 832 192 Z "
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,87,209)",
    stroke: "rgb(48,87,209)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1006.5 155 Q 1025.2 155.8 1033 167.5 L 1039 180.5 L 1039 326.5 Q 1036 338.5 1027.5 345 Q 1020 352 1005.5 352 L 996.5 350 L 984 341.5 Q 978.1 334.9 976 324.5 L 976 182.5 Q 978.3 170.8 985.5 164 L 994.5 158 L 1006.5 155 Z "
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,87,209)",
    stroke: "rgb(48,87,209)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1356.5 200 Q 1360.3 198.8 1359 202.5 L 1358 203.5 L 1358 213.5 Q 1360.5 221.5 1366.5 226 Q 1371.8 230.2 1381.5 230 Q 1391.6 228.1 1396.5 221 L 1403 233.5 L 1404 238.5 L 1404 255.5 Q 1400 272.5 1388.5 282 L 1372.5 291 L 1362.5 293 L 1354.5 293 Q 1353 290.5 1347.5 292 L 1333.5 286 L 1321 274.5 L 1314 261.5 L 1312 252.5 L 1312 240.5 Q 1316 219.5 1330.5 209 L 1341.5 203 L 1356.5 200 Z "
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(48,87,209)",
    stroke: "rgb(48,87,209)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1710.5 200 L 1714 200.5 Q 1710.7 204.2 1712 212.5 Q 1714.3 220.3 1719.5 225 Q 1724.7 230.3 1735.5 230 Q 1745.9 228.4 1750.5 221 L 1757 232.5 L 1759 249.5 L 1757 260.5 L 1753 269.5 L 1741.5 283 Q 1730.3 293.3 1708.5 293 L 1698.5 291 L 1687.5 286 L 1676 275.5 L 1668 260.5 L 1666 244.5 L 1667 243.5 L 1668 232.5 L 1672 223.5 L 1683.5 210 L 1698.5 202 L 1709.5 201 L 1710.5 200 Z "
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,254,254)",
    stroke: "rgb(253,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1342.5 144 L 1369.5 145 L 1387.5 150 Q 1407.7 157.8 1421 172.5 Q 1434.4 186.6 1441 207.5 L 1445 225.5 L 1446 248.5 L 1445 249.5 L 1444 265.5 L 1436 290.5 Q 1426.9 309.4 1411.5 322 Q 1389.5 341.5 1348.5 342 L 1347.5 341 L 1331.5 340 L 1312.5 334 Q 1293.4 325.6 1281 310.5 Q 1268 295.5 1262 273.5 L 1259 258.5 L 1258 238.5 L 1259 237.5 L 1259 226.5 L 1261 215.5 L 1266 199.5 Q 1273.5 181.5 1286.5 169 Q 1297.2 158.7 1311.5 152 L 1325.5 147 L 1342.5 144 Z M 1352 200 Q 1337 203 1328 211 Q 1316 221 1312 238 Q 1310 251 1313 260 L 1322 277 Q 1332 289 1351 293 Q 1375 295 1387 284 Q 1401 273 1405 252 L 1404 236 L 1397 220 Q 1392 226 1385 229 Q 1373 231 1368 226 Q 1360 221 1358 212 Q 1357 204 1360 201 L 1352 200 Z "
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(253,254,254)",
    stroke: "rgb(253,254,254)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 1694.5 144 L 1721.5 145 L 1739.5 150 Q 1760 157.5 1773 172.5 Q 1786.4 186.6 1793 207.5 L 1797 225.5 L 1798 249.5 L 1797 250.5 L 1796 265.5 L 1788 290.5 Q 1778.9 309.4 1763.5 322 Q 1741.5 341.5 1700.5 342 L 1699.5 341 L 1683.5 340 L 1664.5 334 Q 1645.4 325.6 1633 310.5 Q 1620 295.5 1614 273.5 L 1611 257.5 L 1610 239.5 L 1611 238.5 L 1611 226.5 L 1613 215.5 L 1619 197.5 Q 1628.4 176.4 1645.5 163 Q 1655.4 154.9 1668.5 150 L 1681.5 146 L 1693.5 145 L 1694.5 144 Z M 1706 200 Q 1693 202 1685 209 Q 1670 219 1666 240 L 1667 259 Q 1670 271 1678 279 Q 1688 289 1705 293 Q 1717 295 1725 292 Q 1737 289 1745 281 Q 1756 271 1759 254 Q 1761 231 1751 220 L 1750 222 Q 1746 227 1739 229 Q 1727 231 1722 226 Q 1716 222 1713 215 L 1713 203 L 1714 202 L 1714 200 L 1706 200 Z "
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1340.5 0 L 1355.5 0 L 1356.5 1 L 1365.5 1 L 1382.5 4 L 1426.5 19 Q 1470.8 38.7 1504 69.5 L 1505 75.5 L 1500.5 81 L 1486.5 88 L 1468.5 94 L 1446.5 99 L 1428.5 101 L 1427.5 102 L 1419.5 102 L 1418.5 103 L 1409.5 103 L 1408.5 104 L 1358.5 105 L 1347 103 Q 1348 93.3 1355 88.5 L 1350.5 88 L 1349.5 89 L 1319.5 89 L 1318.5 88 L 1303.5 88 L 1302.5 87 L 1286.5 86 L 1277 83 L 1279 75.5 L 1291.5 63 L 1294 61.5 Q 1294.9 58.1 1289.5 60 L 1262.5 54 L 1248 48.5 L 1248 44.5 L 1255.5 36 Q 1271.8 21.3 1293.5 12 L 1316.5 4 L 1331.5 1 L 1339.5 1 L 1340.5 0 Z "
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1704.5 0 L 1734.5 0 L 1735.5 1 L 1746.5 2 L 1763.5 7 Q 1797.3 18.7 1819 42.5 L 1820 47.5 L 1816.5 50 L 1806.5 53 L 1775.5 59 L 1774 60.5 L 1788 73.5 Q 1791.6 75.4 1791 81.5 L 1782.5 85 L 1768.5 86 L 1767.5 87 L 1714 88.5 L 1720 96.5 L 1721 101.5 L 1719.5 103 Q 1714.7 101.8 1713.5 104 L 1670.5 104 L 1669.5 103 L 1656.5 103 L 1655.5 102 L 1631.5 100 L 1598.5 93 L 1578.5 86 Q 1568.6 82.9 1563 75.5 Q 1562.4 70.1 1564 68 L 1602.5 39 L 1637.5 20 L 1678.5 5 L 1704.5 0 Z "
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1338.5 144 L 1342 144.5 L 1338.5 145 L 1338.5 144 Z "
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1362.5 144 L 1366 144.5 L 1362.5 145 L 1362.5 144 Z "
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1690.5 144 L 1694 144.5 L 1690.5 145 L 1690.5 144 Z "
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1714.5 144 L 1718 144.5 L 1714.5 145 L 1714.5 144 Z "
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1332.5 145 L 1335 145.5 L 1332.5 146 L 1332.5 145 Z "
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1684.5 145 L 1687 145.5 L 1684.5 146 L 1684.5 145 Z "
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1304.5 155 L 1303.5 157 L 1304.5 155 Z "
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1656.5 155 L 1655.5 157 L 1656.5 155 Z "
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1404.5 158 L 1405.5 160 L 1404.5 158 Z "
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1407.5 160 L 1408.5 162 L 1407.5 160 Z "
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1759.5 160 L 1760.5 162 L 1759.5 160 Z "
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1295.5 161 L 1294.5 163 L 1295.5 161 Z "
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1647.5 161 L 1646.5 163 L 1647.5 161 Z "
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1291.5 164 L 1287.5 169 L 1291.5 164 Z "
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1412.5 164 L 1414.5 167 L 1412.5 164 Z "
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1643.5 164 L 1632.5 176 L 1643.5 164 Z "
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1764.5 164 L 1766.5 167 L 1764.5 164 Z "
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1284.5 171 L 1280.5 176 L 1284.5 171 Z "
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1421.5 173 L 1424.5 177 L 1421.5 173 Z "
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1773.5 173 L 1776.5 177 L 1773.5 173 Z "
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1630.5 178 L 1629.5 180 L 1630.5 178 Z "
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1426.5 179 L 1427.5 181 L 1426.5 179 Z "
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1778.5 179 L 1779.5 181 L 1778.5 179 Z "
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1275.5 182 L 1274.5 184 L 1275.5 182 Z "
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1627.5 182 L 1626.5 184 L 1627.5 182 Z "
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1351.5 200 L 1356 200.5 L 1351.5 201 L 1351.5 200 Z "
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1705.5 200 L 1710 200.5 L 1705.5 201 L 1705.5 200 Z "
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1712.5 204 L 1713 212.5 L 1712 212.5 L 1712.5 204 Z "
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1327.5 211 L 1323.5 216 L 1327.5 211 Z "
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1396.5 220 L 1397.5 222 L 1396.5 221 L 1391 225.5 L 1396.5 220 Z "
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1750.5 220 L 1751.5 222 L 1750.5 220 Z "
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1362.5 221 L 1366.5 226 L 1362.5 221 Z "
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1444.5 222 L 1445 224.5 L 1444 224.5 L 1444.5 222 Z "
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1717.5 222 L 1719.5 225 L 1717.5 222 Z "
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1796.5 222 L 1797 224.5 L 1796 224.5 L 1796.5 222 Z "
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1259.5 223 L 1260 225.5 L 1259 225.5 L 1259.5 223 Z "
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1611.5 223 L 1612 225.5 L 1611 225.5 L 1611.5 223 Z "
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1376.5 229 L 1382 229.5 L 1376.5 230 L 1376.5 229 Z "
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1445.5 229 L 1446 234.5 L 1445 234.5 L 1445.5 229 Z "
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1730.5 229 L 1736 229.5 L 1730.5 230 L 1730.5 229 Z "
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1797.5 229 L 1798 234.5 L 1797 234.5 L 1797.5 229 Z "
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1258.5 231 L 1259 237.5 L 1258 237.5 L 1258.5 231 Z "
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1610.5 231 L 1611 238.5 L 1610 238.5 L 1610.5 231 Z "
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1403.5 235 L 1404 237.5 L 1403 237.5 L 1403.5 235 Z "
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1312.5 237 L 1313 239.5 L 1312 239.5 L 1312.5 237 Z "
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1666.5 239 L 1667 243.5 L 1666 243.5 L 1666.5 239 Z "
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1758.5 239 L 1759 242.5 L 1758 242.5 L 1758.5 239 Z "
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1404.5 241 L 1405 251.5 L 1404 251.5 L 1404.5 241 Z "
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1610.5 245 L 1611 253.5 L 1610 253.5 L 1610.5 245 Z "
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1258.5 246 L 1259 253.5 L 1258 253.5 L 1258.5 246 Z "
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1445.5 249 L 1446 254.5 L 1445 254.5 L 1445.5 249 Z "
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1666.5 249 L 1667 253.5 L 1666 253.5 L 1666.5 249 Z "
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1758.5 250 L 1759 253.5 L 1758 253.5 L 1758.5 250 Z "
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1797.5 250 L 1798 254.5 L 1797 254.5 L 1797.5 250 Z "
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1312.5 253 L 1313 255.5 L 1312 255.5 L 1312.5 253 Z "
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1611.5 258 L 1612 261.5 L 1611 261.5 L 1611.5 258 Z "
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1259.5 259 L 1260 261.5 L 1259 261.5 L 1259.5 259 Z "
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1444.5 260 L 1445 262.5 L 1444 262.5 L 1444.5 260 Z "
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1796.5 260 L 1797 262.5 L 1796 262.5 L 1796.5 260 Z "
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1672.5 270 L 1673.5 272 L 1672.5 270 Z "
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1752.5 270 L 1751.5 272 L 1752.5 270 Z "
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1319.5 272 L 1320.5 274 L 1319.5 272 Z "
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1674.5 273 L 1675.5 275 L 1674.5 273 Z "
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1750.5 273 L 1749.5 275 L 1750.5 273 Z "
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1395.5 274 L 1394.5 276 L 1395.5 274 Z "
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1322.5 276 L 1328.5 283 L 1322.5 276 Z "
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1678.5 278 L 1680.5 281 L 1678.5 278 Z "
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1746.5 278 L 1744.5 281 L 1746.5 278 Z "
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1387.5 282 L 1386.5 284 L 1387.5 282 Z "
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1684.5 283 L 1685.5 285 L 1684.5 283 Z "
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1740.5 283 L 1739.5 285 L 1740.5 283 Z "
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1524.5 284 Q 1565.6 284.9 1585 307.5 Q 1595.4 318.6 1601 334.5 L 1604 347.5 L 1604 369.5 L 1601 382.5 L 1574 453.5 Q 1569 464 1560.5 471 Q 1552.8 477.8 1541.5 481 L 1537.5 482 L 1518.5 482 Q 1500.2 477.8 1490 465.5 L 1481 450.5 L 1454 378.5 L 1452 368.5 L 1452 348.5 Q 1457.7 316.2 1479.5 300 L 1499.5 289 L 1509.5 286 L 1523.5 285 L 1524.5 284 Z "
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1350.5 292 L 1354 292.5 L 1350.5 293 L 1350.5 292 Z "
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1363.5 292 L 1366 292.5 L 1363.5 293 L 1363.5 292 Z "
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1704.5 292 L 1708 292.5 L 1704.5 293 L 1704.5 292 Z "
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1717.5 292 L 1721 292.5 L 1717.5 293 L 1717.5 292 Z "
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1430.5 300 L 1429.5 302 L 1430.5 300 Z "
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1782.5 300 L 1781.5 302 L 1782.5 300 Z "
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1428.5 303 L 1427.5 305 L 1428.5 303 Z "
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1780.5 303 L 1779.5 305 L 1780.5 303 Z "
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1278.5 307 L 1280.5 310 L 1278.5 307 Z "
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1425.5 307 L 1424.5 309 L 1425.5 307 Z "
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1777.5 307 L 1776.5 309 L 1777.5 307 Z "
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1631.5 308 L 1632.5 310 L 1631.5 308 Z "
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1420.5 313 L 1415.5 319 L 1420.5 313 Z "
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1772.5 313 L 1767.5 319 L 1772.5 313 Z "
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1285.5 315 L 1286.5 317 L 1285.5 315 Z "
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1292.5 321 L 1294.5 324 L 1292.5 321 Z "
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1644.5 321 L 1645.5 323 L 1644.5 321 Z "
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1410.5 322 L 1409.5 324 L 1410.5 322 Z "
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1762.5 322 L 1761.5 324 L 1762.5 322 Z "
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1654.5 328 L 1655.5 330 L 1654.5 328 Z "
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1334.5 340 L 1337 340.5 L 1334.5 341 L 1334.5 340 Z "
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1367.5 340 L 1370 340.5 L 1367.5 341 L 1367.5 340 Z "
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1686.5 340 L 1689 340.5 L 1686.5 341 L 1686.5 340 Z "
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1719.5 340 L 1722 340.5 L 1719.5 341 L 1719.5 340 Z "
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1341.5 341 L 1348 341.5 L 1341.5 342 L 1341.5 341 Z "
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1357.5 341 L 1363 341.5 L 1357.5 342 L 1357.5 341 Z "
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1693.5 341 L 1700 341.5 L 1693.5 342 L 1693.5 341 Z "
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(99,229,221)",
    stroke: "rgb(99,229,221)",
    strokeWidth: 1,
    opacity: 0.984313725490196,
    d: "M 1709.5 341 L 1715 341.5 L 1709.5 342 L 1709.5 341 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClovai);
export default __webpack_public_path__ + "static/media/logo-clovai.06108fed9887228a89c41f4412035fa0.svg";
export { ForwardRef as ReactComponent };